export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Banking account number is a string of 5 to 17 alphanumeric values for representing an generic account number */
  AccountNumber: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: { input: any; output: any; }
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: { input: any; output: any; }
  /** A country name (short name) as defined by ISO 3166-1 */
  CountryName: { input: any; output: any; }
  /** A field whose value conforms to the standard cuid format as specified in https://github.com/ericelliott/cuid#broken-down */
  Cuid: { input: any; output: any; }
  /** A field whose value conforms to the cuid2 format, as specified in https://github.com/paralleldrive/cuid2 */
  Cuid2: { input: any; output: any; }
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: { input: any; output: any; }
  /** A field whose value conforms to the standard DID format as specified in did-core: https://www.w3.org/TR/did-core/. */
  DID: { input: any; output: any; }
  /** A custom scalar for Date with format YYYY-MM-DD */
  Date: { input: any; output: any; }
  /** A custom scalar for DateOfBirth with format YYYY-MM-DD */
  DateOfBirth: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** A field whose value conforms to the standard DeweyDecimal format as specified by the OCLC https://www.oclc.org/content/dam/oclc/dewey/resources/summaries/deweysummaries.pdf */
  DeweyDecimal: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  Duration: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  GUID: { input: any; output: any; }
  /** A GeoJSON object as defined by RFC 7946: https://datatracker.ietf.org/doc/html/rfc7946 */
  GeoJSON: { input: any; output: any; }
  /** A field whose value is a CSS HSL color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSL: { input: any; output: any; }
  /** A field whose value is a CSS HSLA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSLA: { input: any; output: any; }
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: { input: any; output: any; }
  /** A field whose value is a hexadecimal: https://en.wikipedia.org/wiki/Hexadecimal. */
  Hexadecimal: { input: any; output: any; }
  /** A field whose value is an International Bank Account Number (IBAN): https://en.wikipedia.org/wiki/International_Bank_Account_Number. */
  IBAN: { input: any; output: any; }
  /** A field whose value is either an IPv4 or IPv6 address: https://en.wikipedia.org/wiki/IP_address. */
  IP: { input: any; output: any; }
  /** A field whose value is an IPC Class Symbol within the International Patent Classification System: https://www.wipo.int/classifications/ipc/en/ */
  IPCPatent: { input: any; output: any; }
  /** A field whose value is a IPv4 address: https://en.wikipedia.org/wiki/IPv4. */
  IPv4: { input: any; output: any; }
  /** A field whose value is a IPv6 address: https://en.wikipedia.org/wiki/IPv6. */
  IPv6: { input: any; output: any; }
  /** A field whose value is a ISBN-10 or ISBN-13 number: https://en.wikipedia.org/wiki/International_Standard_Book_Number. */
  ISBN: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  ISO8601Duration: { input: any; output: any; }
  IntStringBoolean: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: { input: any; output: any; }
  /** A field whose value conforms to the Library of Congress Subclass Format ttps://www.loc.gov/catdir/cpso/lcco/ */
  LCCSubclass: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: { input: any; output: any; }
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: { input: any; output: any; }
  /** A local date-time string (i.e., with no associated timezone) in `YYYY-MM-DDTHH:mm:ss` format, e.g. `2020-01-01T00:00:00`. */
  LocalDateTime: { input: any; output: any; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`.  This scalar is very similar to the `LocalTime`, with the only difference being that `LocalEndTime` also allows `24:00` as a valid value to indicate midnight of the following day.  This is useful when using the scalar to represent the exclusive upper bound of a time block. */
  LocalEndTime: { input: any; output: any; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: { input: any; output: any; }
  /** The locale in the format of a BCP 47 (RFC 5646) standard string */
  Locale: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: { input: any; output: any; }
  /** A field whose value is a IEEE 802 48-bit MAC address: https://en.wikipedia.org/wiki/MAC_address. */
  MAC: { input: any; output: any; }
  /** Floats that will have a value less than 0. */
  NegativeFloat: { input: any; output: any; }
  /** Integers that will have a value less than 0. */
  NegativeInt: { input: any; output: any; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: any; output: any; }
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: { input: any; output: any; }
  /** Floats that will have a value of 0 or less. */
  NonPositiveFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: { input: any; output: any; }
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: { input: any; output: any; }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: { input: any; output: any; }
  /** A field whose value is a valid TCP port within the range of 0 to 65535: https://en.wikipedia.org/wiki/Transmission_Control_Protocol#TCP_ports */
  Port: { input: any; output: any; }
  /** Floats that will have a value greater than 0. */
  PositiveFloat: { input: any; output: any; }
  /** Integers that will have a value greater than 0. */
  PositiveInt: { input: any; output: any; }
  /** A field whose value conforms to the standard postal code formats for United States, United Kingdom, Germany, Canada, France, Italy, Australia, Netherlands, Spain, Denmark, Sweden, Belgium, India, Austria, Portugal, Switzerland or Luxembourg. */
  PostalCode: { input: any; output: any; }
  /** A field whose value is a CSS RGB color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGB: { input: any; output: any; }
  /** A field whose value is a CSS RGBA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGBA: { input: any; output: any; }
  /** In the US, an ABA routing transit number (`ABA RTN`) is a nine-digit code to identify the financial institution. */
  RoutingNumber: { input: any; output: any; }
  /** A field whose value conforms to the standard personal number (personnummer) formats for Sweden */
  SESSN: { input: any; output: any; }
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: any; output: any; }
  /** A field whose value is a Semantic Version: https://semver.org */
  SemVer: { input: any; output: any; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: any; output: any; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: any; output: any; }
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
  /** A ULID (Universally Unique Lexicographically Sortable Identifier) is a 26-character string that is URL-safe, case-insensitive, and lexicographically sortable. */
  ULID: { input: any; output: any; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any; }
  /** A currency string, such as $21.25 */
  USCurrency: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
  /** Floats that will have a value of 0 or more. */
  UnsignedFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  UnsignedInt: { input: any; output: any; }
  /** A field whose value is a UTC Offset: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  UtcOffset: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type Account = {
  accountIdentifier?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  balanceInCents?: Maybe<Scalars['Float']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  contributionsManagedExternally: Scalars['Boolean']['output'];
  /** @deprecated Use documents query instead */
  documents?: Maybe<Array<Maybe<Document>>>;
  harvestLongTermCapitalGains?: Maybe<Scalars['Boolean']['output']>;
  harvestRecommendedFloorUsd: Scalars['Int']['output'];
  harvestStandardDeduction?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inAppContributionsAllowed: Scalars['Boolean']['output'];
  isHalfmoreSetupPending: Scalars['Boolean']['output'];
  needsPayrollSetup: Scalars['Boolean']['output'];
  routingNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AccountStatus>;
  subaccounts?: Maybe<Array<Maybe<Subaccount>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccountType>;
};

export type AccountInput = {
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
};

export enum AccountProvider {
  Alpaca = 'ALPACA',
  Altruist = 'ALTRUIST',
  AtomicBrokerage = 'ATOMIC_BROKERAGE',
  AtomicInvest = 'ATOMIC_INVEST',
  CapitalGroup = 'CAPITAL_GROUP'
}

export enum AccountStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  InReview = 'IN_REVIEW',
  New = 'NEW',
  Pending = 'PENDING',
  PendingClosure = 'PENDING_CLOSURE',
  Rejected = 'REJECTED'
}

export enum AccountType {
  Cash = 'CASH',
  Corporate = 'CORPORATE',
  CustodialRothIra = 'CUSTODIAL_ROTH_IRA',
  FiveTwoNinePlan = 'FIVE_TWO_NINE_PLAN',
  GeneralInvesting = 'GENERAL_INVESTING',
  HarvestUtmaUgma = 'HARVEST_UTMA_UGMA',
  Individual = 'INDIVIDUAL',
  Individual_529 = 'INDIVIDUAL_529',
  IraRoth = 'IRA_ROTH',
  IraSep = 'IRA_SEP',
  IraTraditional = 'IRA_TRADITIONAL',
  Joint = 'JOINT',
  JuniorIraRoth = 'JUNIOR_IRA_ROTH',
  JuniorRothIra = 'JUNIOR_ROTH_IRA',
  Reserve = 'RESERVE',
  RothIra = 'ROTH_IRA',
  TraditionalIra = 'TRADITIONAL_IRA'
}

export type ActionShareGoalInviteInput = {
  accountType?: InputMaybe<AccountType>;
  action: ShareGoalInviteAction;
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  recurringDepositInCents?: InputMaybe<Scalars['Int']['input']>;
  recurringDepositSchedule?: InputMaybe<SipFrequency>;
  shareGoalInviteId: Scalars['String']['input'];
  targetAmountInCents?: InputMaybe<Scalars['Float']['input']>;
};

export type AddBeneficiaryInput = {
  countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateOfBirth']['input']>;
  dueDate?: InputMaybe<Scalars['DateOfBirth']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  incomeAt18?: InputMaybe<IncomeAt18>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<BeneficiaryRelationship>;
  stateOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<UserTaxIdType>;
  type: BeneficiaryType;
};

export type AddGoalInput = {
  accountType: AccountType;
  beneficiaryId: Scalars['String']['input'];
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  expectedTaxBillWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  expectedTaxBillWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<GoalType>;
  harvestLongTermCapitalGains?: InputMaybe<Scalars['Boolean']['input']>;
  harvestRecommendedFloorUsd?: InputMaybe<Scalars['Int']['input']>;
  harvestStandardDeduction?: InputMaybe<Scalars['Boolean']['input']>;
  incomeAt18?: InputMaybe<IncomeAt18>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  recurringDepositInCents?: InputMaybe<Scalars['Int']['input']>;
  recurringDepositSchedule?: InputMaybe<SipFrequency>;
  spendableWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  spendableWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  targetAmountInCents?: InputMaybe<Scalars['Float']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
  trumpAccountBalanceInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionFrequency?: InputMaybe<TrumpContributionFrequency>;
};

export type AddGoalWithBeneficiaryInput = {
  accountType: AccountType;
  beneficiary: AddBeneficiaryInput;
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  expectedTaxBillWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  expectedTaxBillWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<GoalType>;
  harvestLongTermCapitalGains?: InputMaybe<Scalars['Boolean']['input']>;
  harvestRecommendedFloorUsd?: InputMaybe<Scalars['Int']['input']>;
  harvestStandardDeduction?: InputMaybe<Scalars['Boolean']['input']>;
  incomeAt18?: InputMaybe<IncomeAt18>;
  projectedRateOfReturn: Scalars['Float']['input'];
  recurringDepositInCents?: InputMaybe<Scalars['Int']['input']>;
  recurringDepositSchedule?: InputMaybe<SipFrequency>;
  spendableWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  spendableWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  targetAmountInCents: Scalars['Float']['input'];
  targetYear?: InputMaybe<Scalars['Int']['input']>;
  trumpAccountBalanceInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionFrequency?: InputMaybe<TrumpContributionFrequency>;
};

export type AddGoalWithBeneficiaryPayload = {
  beneficiary: Beneficiary;
  goal: Goal;
};

export type AddressDetails = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  placeId: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type AddressPrediction = {
  description: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
};

export type AddressPredictions = {
  input: Scalars['String']['output'];
  predictions?: Maybe<Array<Maybe<AddressPrediction>>>;
};

export type Agreement = {
  description?: Maybe<Scalars['String']['output']>;
  effectiveFrom: Scalars['DateTime']['output'];
  esignatureRequired: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: AgreementType;
  /**
   * Short-lived link to the agreement document, when one exists. Null for agreements consented to
   * in-app against clickwrap copy the client renders itself, which is the case for the Capital Group
   * 529 migration today.
   */
  url?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export enum AgreementType {
  CapitalGroup_529MigrationTerms = 'CAPITAL_GROUP_529_MIGRATION_TERMS'
}

export type AllocatePromotionalDollarsInput = {
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  destinationGoalId?: InputMaybe<Scalars['String']['input']>;
};

export type ApplyDefaultPromoCodePayload = {
  amountInDollars: Scalars['Float']['output'];
  isDefaultPromoCode: Scalars['Boolean']['output'];
};

export type AsaLoginResponse = {
  loginUrl: Scalars['String']['output'];
};

export type AssetClassExposure = {
  factorPercentage: Scalars['Float']['output'];
  name: PortfolioAssetExposureNames;
};

export type Authorization = {
  sessionJwt: Scalars['String']['output'];
  sessionToken?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type AvailableToWithdrawInCentsInput = {
  goalId: Scalars['String']['input'];
  subaccountId?: InputMaybe<Scalars['String']['input']>;
};

export type AvailableToWithdrawInCentsOutput = {
  grossAvailableToWithdrawInCents?: Maybe<Scalars['Int']['output']>;
  isWithdrawalAllInitiated?: Maybe<Scalars['Boolean']['output']>;
  lockedPromotionalDollarsInCents?: Maybe<Scalars['Int']['output']>;
  netAvailableToWithdrawInCents?: Maybe<Scalars['Int']['output']>;
  pendingContributionsInCents?: Maybe<Scalars['Int']['output']>;
  pendingWithdrawalsInCents?: Maybe<Scalars['Int']['output']>;
};

export type BankAccount = {
  accountNumber?: Maybe<Scalars['String']['output']>;
  assetColor?: Maybe<Scalars['String']['output']>;
  assetLogo?: Maybe<Scalars['String']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  useForBilling?: Maybe<Scalars['Boolean']['output']>;
};

export type BankLink = {
  assets?: Maybe<BankLinkAssets>;
  id?: Maybe<Scalars['String']['output']>;
  providerInstitutionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BankLinkStatus>;
};

export type BankLinkAssets = {
  color?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum BankLinkProvider {
  Plaid = 'PLAID',
  Plain = 'PLAIN',
  Yodlee = 'YODLEE'
}

export enum BankLinkStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED'
}

export type Beneficiary = {
  dateOfBirth?: Maybe<Scalars['DateOfBirth']['output']>;
  dueDate?: Maybe<Scalars['DateOfBirth']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  id?: Maybe<Scalars['String']['output']>;
  incomeAt18?: Maybe<IncomeAt18>;
  lastName?: Maybe<Scalars['String']['output']>;
  taxIdProvided?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<BeneficiaryType>;
};

export type BeneficiaryGiftingLink = {
  giftingCode: Scalars['String']['output'];
  giftingUrl: Scalars['String']['output'];
  isGiftingCodeConfirmed: Scalars['Boolean']['output'];
};

export enum BeneficiaryRelationship {
  Brother = 'BROTHER',
  Daughter = 'DAUGHTER',
  Father = 'FATHER',
  FatherInLaw = 'FATHER_IN_LAW',
  Granddaughter = 'GRANDDAUGHTER',
  Grandfather = 'GRANDFATHER',
  Grandmother = 'GRANDMOTHER',
  Grandson = 'GRANDSON',
  Mother = 'MOTHER',
  MotherInLaw = 'MOTHER_IN_LAW',
  Nephew = 'NEPHEW',
  Niece = 'NIECE',
  Self = 'SELF',
  Sister = 'SISTER',
  Son = 'SON',
  Spouse = 'SPOUSE'
}

export enum BeneficiaryType {
  Adult = 'ADULT',
  Child = 'CHILD',
  Self = 'SELF'
}

export enum BillingInterval {
  Annually = 'ANNUALLY',
  Free = 'FREE',
  Monthly = 'MONTHLY'
}

export type BusinessAddress = {
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CancelContributionInput = {
  transactionId: Scalars['String']['input'];
};

export type ChangeRecurringDepositInput = {
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<SipFrequency>;
  /** @deprecated Use pauseSip mutation instead */
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  sipId: Scalars['String']['input'];
};

export type CheckGiftingCodeAvailabilityInput = {
  beneficiaryId: Scalars['String']['input'];
  giftingCode: Scalars['String']['input'];
};

export type CheckGiftingCodeAvailabilityOutput = {
  isAvailable: Scalars['Boolean']['output'];
};

export type CheckHalfmoreAvailabilityOutput = {
  isAvailable: Scalars['Boolean']['output'];
  stateCode: Scalars['String']['output'];
};

export type Child = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['DateOfBirth']['output']>;
  /** @deprecated Use beneficiaries query instead */
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFutureChild?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use beneficiaries -> goals -> sip query to get SIPs instead */
  sips?: Maybe<Array<Maybe<Sip>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompletePartnerOnboardingInput = {
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  goalId: Scalars['String']['input'];
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  recurringDepositInCents?: InputMaybe<Scalars['Int']['input']>;
  recurringDepositSchedule?: InputMaybe<SipFrequency>;
  setupSip: Scalars['Boolean']['input'];
  targetAmountInCents: Scalars['Float']['input'];
  targetYear?: InputMaybe<Scalars['Int']['input']>;
};

export type ConfirmBeneficiaryGiftingCodeOutput = {
  giftingCode: Scalars['String']['output'];
  giftingUrl: Scalars['String']['output'];
  isGiftingCodeConfirmed: Scalars['Boolean']['output'];
};

export type Consent = {
  agreementId: Scalars['String']['output'];
  agreementType: AgreementType;
  agreementVersion: Scalars['String']['output'];
  id: Scalars['String']['output'];
  signedTimestamp: Scalars['DateTime']['output'];
  viewedTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type CreateConsentInput = {
  agreementId: Scalars['String']['input'];
  /** When the user opened the agreement. A future value is clamped to the server's time. */
  viewedTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateFamerShakeEntryInput = {
  address: UserAddressInput;
  dateOfBirth: Scalars['DateOfBirth']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateOneTimeDepositInput = {
  amountInCents: Scalars['Int']['input'];
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field will be deprecated in the next releases */
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  goalId: Scalars['String']['input'];
  subaccountId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRecurringDepositInput = {
  amountInCents: Scalars['Int']['input'];
  frequency: SipFrequency;
  goalId: Scalars['String']['input'];
  subaccountId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSquadInput = {
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateTermsConsentInput = {
  viewedTimestamp: Scalars['DateTime']['input'];
};

export type CreateWithdrawalInput = {
  amountInCents: Scalars['Int']['input'];
  cancelExistingWithdrawal?: InputMaybe<Scalars['Boolean']['input']>;
  goalId: Scalars['String']['input'];
  subaccountId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WithdrawalType>;
};

export type CurrentAgreementInput = {
  type: AgreementType;
};

export type CurrentWeekShakeStatus = {
  friday: Scalars['Boolean']['output'];
  monday: Scalars['Boolean']['output'];
  saturday: Scalars['Boolean']['output'];
  sunday: Scalars['Boolean']['output'];
  thursday: Scalars['Boolean']['output'];
  tuesday: Scalars['Boolean']['output'];
  wednesday: Scalars['Boolean']['output'];
};

export type DefaultProjectedRateOfReturnInput = {
  accountType: AccountType;
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteInviteToShareGoalInput = {
  shareGoalInviteId: Scalars['String']['input'];
};

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Document = {
  documentDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DocumentType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentInput = {
  documentId: Scalars['String']['input'];
};

export enum DocumentType {
  AccountStatement = 'ACCOUNT_STATEMENT',
  Tax = 'TAX',
  TradeConfirmation = 'TRADE_CONFIRMATION'
}

export type DocumentTypeInfo = {
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: DocumentType;
  unreadCount: Scalars['Int']['output'];
};

export type DocumentsInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  types: Array<DocumentType>;
};

export type EditGoalInput = {
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  expectedRolloverAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  expectedTaxBillWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  expectedTaxBillWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  goalId: Scalars['String']['input'];
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<GoalType>;
  incomeAt18?: InputMaybe<IncomeAt18>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  spendableWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  spendableWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  targetAmountInCents?: InputMaybe<Scalars['Float']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
  trumpAccountBalanceInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionFrequency?: InputMaybe<TrumpContributionFrequency>;
};

export type Entry = {
  createdAt: Scalars['DateTime']['output'];
  drawId: Scalars['String']['output'];
  entries: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  type: EntryType;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum EntryType {
  FameEntry = 'FAME_ENTRY',
  InvestmentEntry = 'INVESTMENT_ENTRY',
  ShakeEntry = 'SHAKE_ENTRY',
  SquadEntry = 'SQUAD_ENTRY'
}

export type FailedAchContribution = {
  createdAt: Scalars['String']['output'];
  failedTransaction?: Maybe<Transaction>;
  id: Scalars['ID']['output'];
  occurrenceNumber: Scalars['Int']['output'];
  returnCode?: Maybe<Scalars['String']['output']>;
  returnReason?: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['ID']['output'];
};

export type FamerEntry = {
  createdAt: Scalars['DateTime']['output'];
  currentWeekEntryCount: Scalars['Int']['output'];
  drawId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type FeatureFlag = {
  name: Scalars['String']['output'];
  value: Scalars['IntStringBoolean']['output'];
};

export enum FlexibilityPreference {
  SomewhatFlexible = 'SOMEWHAT_FLEXIBLE',
  SomewhatTaxAdvantaged = 'SOMEWHAT_TAX_ADVANTAGED',
  VeryFlexible = 'VERY_FLEXIBLE',
  VeryTaxAdvantaged = 'VERY_TAX_ADVANTAGED'
}

export type GetBankLinkTokenInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type GetBankLinkTokenPayload = {
  provider: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type GetHalfmoreRedirectionOutput = {
  halfmoreLink: Scalars['String']['output'];
};

export type GiftingIntent = {
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  gifterEmail: Scalars['String']['output'];
  gifterName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  initiatedBy: GiftingIntentInitiatedBy;
  message?: Maybe<Scalars['String']['output']>;
  occasion?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentStatus: GiftingIntentPaymentStatus;
  recipientEmail: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  recipientPhoneNumber: Scalars['String']['output'];
  recipientReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  redeemedAt?: Maybe<Scalars['DateTime']['output']>;
  redemptionStatus: GiftingIntentRedemptionStatus;
  relationship?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum GiftingIntentInitiatedBy {
  Gifter = 'GIFTER',
  Recipient = 'RECIPIENT'
}

export enum GiftingIntentPaymentStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  New = 'NEW',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Succeeded = 'SUCCEEDED'
}

export enum GiftingIntentRedemptionStatus {
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  New = 'NEW',
  Processing = 'PROCESSING',
  Redeemed = 'REDEEMED'
}

export type Goal = {
  accounts?: Maybe<Array<Maybe<Account>>>;
  contributionsAfter18?: Maybe<Scalars['Boolean']['output']>;
  currentAmountInCents?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  estimatedIrsBillInCents?: Maybe<Scalars['Int']['output']>;
  expectedRolloverAmountInCents?: Maybe<Scalars['Int']['output']>;
  expectedTaxBillWithSidecarInCents?: Maybe<Scalars['Float']['output']>;
  expectedTaxBillWithoutSidecarInCents?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partners?: Maybe<Array<Maybe<Partner>>>;
  projectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  sips?: Maybe<Array<Maybe<Sip>>>;
  spendableWithSidecarInCents?: Maybe<Scalars['Float']['output']>;
  spendableWithoutSidecarInCents?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<GoalStatus>;
  targetAmountInCents?: Maybe<Scalars['Float']['output']>;
  trumpAccountBalanceInCents?: Maybe<Scalars['Int']['output']>;
  trumpAccountBalanceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  trumpContributionAmountInCents?: Maybe<Scalars['Int']['output']>;
  trumpContributionFrequency?: Maybe<TrumpContributionFrequency>;
  type?: Maybe<GoalType>;
};

export enum GoalStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  New = 'NEW',
  OnHold = 'ON_HOLD'
}

export enum GoalType {
  Custom = 'CUSTOM',
  Education = 'EDUCATION',
  EmergencyFund = 'EMERGENCY_FUND',
  GenerationalWealth = 'GENERATIONAL_WEALTH',
  HighYieldSavings = 'HIGH_YIELD_SAVINGS',
  House = 'HOUSE',
  NewCar = 'NEW_CAR',
  Retirement = 'RETIREMENT',
  TrumpAccountSidecar = 'TRUMP_ACCOUNT_SIDECAR',
  Vacation = 'VACATION'
}

export type HandleExternalManageAccountInput = {
  goalId: Scalars['String']['input'];
};

export type HandleExternalManageAccountOutput = {
  halfmoreLink?: Maybe<Scalars['String']['output']>;
  hasUserCompletedHalfmoreOnboarding: Scalars['Boolean']['output'];
  otp?: Maybe<OtpDetails>;
};

export type HandleHalfmoreWaitlistInput = {
  goalId: Scalars['String']['input'];
};

export type HandleSelfManageAccountInput = {
  goalId: Scalars['String']['input'];
};

export type HarvestAccountConfigs = {
  harvestLongTermCapitalGains: Scalars['Boolean']['output'];
  harvestRecommendedFloorUsd: Scalars['Int']['output'];
  harvestStandardDeduction: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
};

export type HarvestAccountDefaultConfigsInput = {
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
};

export type HasScheduledContributionsOutput = {
  activeSipIds: Array<Scalars['String']['output']>;
  hasScheduledContributions: Scalars['Boolean']['output'];
  scheduledTransactionIds: Array<Scalars['String']['output']>;
};

export enum IncomeAt18 {
  FullTimeStudent = 'FULL_TIME_STUDENT',
  WorkingFullTime = 'WORKING_FULL_TIME'
}

export type InitiateLoginWithPhoneInput = {
  phoneNumber: Scalars['String']['input'];
};

export type InitiateResetPasswordInput = {
  email: Scalars['String']['input'];
};

export type InviteToShareGoalInput = {
  goalId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type Invoice = {
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  providerDiscountId?: Maybe<Scalars['String']['output']>;
  providerInvoiceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IsWithdrawalAllowedInput = {
  goalId: Scalars['String']['input'];
  subaccountId?: InputMaybe<Scalars['String']['input']>;
};

export type IsWithdrawalAllowedOutput = {
  allowed: Scalars['Boolean']['output'];
  cancellationRequired: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type JoinSquadInput = {
  name: Scalars['String']['input'];
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginWithOAuthInput = {
  channel?: InputMaybe<OAuthChannel>;
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  jwt?: InputMaybe<Scalars['String']['input']>;
  oauthToken?: InputMaybe<Scalars['String']['input']>;
};

export type LoginWithPhoneInput = {
  code: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type Mutation = {
  /**
   * Clears the one-time Capital Group migration notice after the user acknowledges it, and records
   * that they saw it.
   */
  acknowledgeCapitalGroupMigrationOverride: Scalars['Boolean']['output'];
  actionShareGoalInvite?: Maybe<Goal>;
  addBeneficiary?: Maybe<Beneficiary>;
  addGoal?: Maybe<Goal>;
  /**
   * Creates a beneficiary and a goal in one transaction. Use this when the FE wants to
   * bundle the two operations — during onboarding parallel-submit, or post-onboarding
   * when adding a new goal for a brand-new beneficiary. During onboarding (user.status
   * NEW) risk-level computation is deferred to user-onboarding-service; post-onboarding
   * the goal's risk is computed inline by core's createGoal. Same shared helper as
   * addBeneficiary + addGoal underneath, so the SELF special-case, tax-residence
   * fallbacks, and validation rules stay consistent.
   */
  addGoalWithBeneficiary?: Maybe<AddGoalWithBeneficiaryPayload>;
  allocatePromotionalDollars: Transaction;
  applyDefaultPromoCode: ApplyDefaultPromoCodePayload;
  applyUserProfileClosureRetention?: Maybe<PromotionCode>;
  cancelContribution: Transaction;
  changeRecurringDeposit: Sip;
  completePartnerOnboarding?: Maybe<User>;
  confirmBeneficiaryGiftingCode?: Maybe<ConfirmBeneficiaryGiftingCodeOutput>;
  confirmUserOnboarding?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Records the caller's e-signature against an agreement and applies that agreement's side effects.
   * Idempotent: consenting twice to the same version returns the original record.
   */
  createConsent: Consent;
  createFamerShakeEntry?: Maybe<FamerEntry>;
  createOneTimeDeposit: Transaction;
  createRecurringDeposit: Sip;
  createShakeEntry?: Maybe<Entry>;
  createSquad?: Maybe<Squad>;
  createTermsConsent?: Maybe<Scalars['Boolean']['output']>;
  createTradeConfirmationsConsent?: Maybe<Scalars['Boolean']['output']>;
  createWithdrawal: Transaction;
  deleteInviteToShareGoal?: Maybe<Scalars['Boolean']['output']>;
  editGoal?: Maybe<Goal>;
  handleExternalManageAccount?: Maybe<HandleExternalManageAccountOutput>;
  handleHalfmoreWaitlist?: Maybe<Scalars['Boolean']['output']>;
  handleSelfManageAccount?: Maybe<Scalars['Boolean']['output']>;
  initiateAsaLogin: AsaLoginResponse;
  initiateLoginWithPhone: Scalars['Boolean']['output'];
  initiateResetPassword: Scalars['Boolean']['output'];
  initiateUserProfileClosure?: Maybe<Scalars['Boolean']['output']>;
  inviteToShareGoal?: Maybe<SentShareGoalInvite>;
  joinSquad?: Maybe<Squad>;
  leaveSquad?: Maybe<Scalars['Boolean']['output']>;
  loginUser: Authorization;
  loginWithOAuth: Authorization;
  loginWithPhone: Authorization;
  markGiftAsReceived?: Maybe<GiftingIntent>;
  pauseAllContributions: Scalars['Boolean']['output'];
  pauseRecurringDeposit: Sip;
  processPublicToken?: Maybe<Scalars['Boolean']['output']>;
  redeemPromotionCode?: Maybe<PromotionCode>;
  refreshToken: Authorization;
  registerUser: Authorization;
  registerWithPhone: Scalars['Boolean']['output'];
  removePartnerFromGoal?: Maybe<Goal>;
  removeSquadMember?: Maybe<Scalars['Boolean']['output']>;
  resendInviteToShareGoal?: Maybe<SentShareGoalInvite>;
  resendPhoneVerificationCode?: Maybe<Scalars['Boolean']['output']>;
  resetPassword: Scalars['Boolean']['output'];
  resumeRecurringDeposit: Sip;
  sendDocumentPortalCredentials: Scalars['Boolean']['output'];
  setUserFinancialProfile?: Maybe<UserFinancialProfile>;
  setUserIdentity?: Maybe<User>;
  setUserTaxProfile?: Maybe<User>;
  setUserTrustedContact?: Maybe<UserFinancialProfile>;
  submitUserFeedback?: Maybe<Scalars['Boolean']['output']>;
  syncData?: Maybe<Scalars['Boolean']['output']>;
  updateBeneficiary?: Maybe<Beneficiary>;
  updateBeneficiaryGiftingCode?: Maybe<UpdateBeneficiaryGiftingCodeOutput>;
  updateHarvestAccountConfigs?: Maybe<Account>;
  updateSquad?: Maybe<Squad>;
  updateSubscription?: Maybe<Subscription>;
  validateUserPrefill?: Maybe<Scalars['Boolean']['output']>;
  verifyEmail: Authorization;
  verifyPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  verifyPromotionCode?: Maybe<PromotionCode>;
};


export type MutationActionShareGoalInviteArgs = {
  input: ActionShareGoalInviteInput;
};


export type MutationAddBeneficiaryArgs = {
  input: AddBeneficiaryInput;
};


export type MutationAddGoalArgs = {
  input: AddGoalInput;
};


export type MutationAddGoalWithBeneficiaryArgs = {
  input: AddGoalWithBeneficiaryInput;
};


export type MutationAllocatePromotionalDollarsArgs = {
  input: AllocatePromotionalDollarsInput;
};


export type MutationCancelContributionArgs = {
  input: CancelContributionInput;
};


export type MutationChangeRecurringDepositArgs = {
  input: ChangeRecurringDepositInput;
};


export type MutationCompletePartnerOnboardingArgs = {
  input: CompletePartnerOnboardingInput;
};


export type MutationConfirmBeneficiaryGiftingCodeArgs = {
  beneficiaryId: Scalars['String']['input'];
};


export type MutationCreateConsentArgs = {
  input: CreateConsentInput;
};


export type MutationCreateFamerShakeEntryArgs = {
  input: CreateFamerShakeEntryInput;
};


export type MutationCreateOneTimeDepositArgs = {
  input: CreateOneTimeDepositInput;
};


export type MutationCreateRecurringDepositArgs = {
  input: CreateRecurringDepositInput;
};


export type MutationCreateSquadArgs = {
  input: CreateSquadInput;
};


export type MutationCreateTermsConsentArgs = {
  input: CreateTermsConsentInput;
};


export type MutationCreateWithdrawalArgs = {
  input: CreateWithdrawalInput;
};


export type MutationDeleteInviteToShareGoalArgs = {
  input: DeleteInviteToShareGoalInput;
};


export type MutationEditGoalArgs = {
  input: EditGoalInput;
};


export type MutationHandleExternalManageAccountArgs = {
  input: HandleExternalManageAccountInput;
};


export type MutationHandleHalfmoreWaitlistArgs = {
  input: HandleHalfmoreWaitlistInput;
};


export type MutationHandleSelfManageAccountArgs = {
  input: HandleSelfManageAccountInput;
};


export type MutationInitiateLoginWithPhoneArgs = {
  input: InitiateLoginWithPhoneInput;
};


export type MutationInitiateResetPasswordArgs = {
  input: InitiateResetPasswordInput;
};


export type MutationInviteToShareGoalArgs = {
  input: InviteToShareGoalInput;
};


export type MutationJoinSquadArgs = {
  input: JoinSquadInput;
};


export type MutationLoginUserArgs = {
  input: LoginInput;
};


export type MutationLoginWithOAuthArgs = {
  input: LoginWithOAuthInput;
};


export type MutationLoginWithPhoneArgs = {
  input: LoginWithPhoneInput;
};


export type MutationMarkGiftAsReceivedArgs = {
  giftingIntentId: Scalars['String']['input'];
};


export type MutationPauseRecurringDepositArgs = {
  input: PauseRecurringDepositInput;
};


export type MutationProcessPublicTokenArgs = {
  input: ProcessPublicTokenInput;
};


export type MutationRedeemPromotionCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationRegisterUserArgs = {
  input: RegisterInput;
};


export type MutationRegisterWithPhoneArgs = {
  input: RegisterWithPhoneInput;
};


export type MutationRemovePartnerFromGoalArgs = {
  input: RemovePartnerFromGoalInput;
};


export type MutationRemoveSquadMemberArgs = {
  input: RemoveSquadMemberInput;
};


export type MutationResendInviteToShareGoalArgs = {
  input: ResendInviteToShareGoalInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResumeRecurringDepositArgs = {
  input: ResumeRecurringDepositInput;
};


export type MutationSetUserFinancialProfileArgs = {
  input: SetUserFinancialProfile;
};


export type MutationSetUserIdentityArgs = {
  input: SetUserIdentity;
};


export type MutationSetUserTaxProfileArgs = {
  input: SetUserTaxProfile;
};


export type MutationSetUserTrustedContactArgs = {
  input: SetUserTrustedContact;
};


export type MutationSubmitUserFeedbackArgs = {
  input: SubmitUserFeedbackInput;
};


export type MutationUpdateBeneficiaryArgs = {
  input: UpdateBeneficiaryInput;
};


export type MutationUpdateBeneficiaryGiftingCodeArgs = {
  input: UpdateBeneficiaryGiftingCodeInput;
};


export type MutationUpdateHarvestAccountConfigsArgs = {
  input: UpdateHarvestAccountConfigsInput;
};


export type MutationUpdateSquadArgs = {
  input: UpdateSquadInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationValidateUserPrefillArgs = {
  input: ValidateUserPrefill;
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyPhoneNumberArgs = {
  input: VerifyPhoneNumber;
};


export type MutationVerifyPromotionCodeArgs = {
  code: Scalars['String']['input'];
};

export enum OAuthChannel {
  Apple = 'APPLE',
  Google = 'GOOGLE'
}

export type OtpDetails = {
  code: Scalars['String']['output'];
  expiresAt: Scalars['Float']['output'];
  expiresInMs: Scalars['Float']['output'];
};

export enum OccupationIndustry {
  Accounting = 'ACCOUNTING',
  AdvertisingMarketing = 'ADVERTISING__MARKETING',
  AerospaceDefense = 'AEROSPACE__DEFENSE',
  AgricultureForestry = 'AGRICULTURE__FORESTRY',
  AmusementAndRecreation = 'AMUSEMENT_AND_RECREATION',
  AnimalServicesAndVeterinary = 'ANIMAL_SERVICES_AND_VETERINARY',
  ArchitectureDesign = 'ARCHITECTURE__DESIGN',
  ArtsAntiques = 'ARTS__ANTIQUES',
  AthleticsFitness = 'ATHLETICS__FITNESS',
  Automotive = 'AUTOMOTIVE',
  Aviation = 'AVIATION',
  BarNightclubAdultEntertainmentClub = 'BAR__NIGHTCLUB__ADULT_ENTERTAINMENT_CLUB',
  Childcare = 'CHILDCARE',
  CleaningJanitorialHousekeeping = 'CLEANING__JANITORIAL__HOUSEKEEPING',
  CommunicationsTelecommunications = 'COMMUNICATIONS__TELECOMMUNICATIONS',
  ConstructionCarpentryLandscaping = 'CONSTRUCTION__CARPENTRY__LANDSCAPING',
  ConvenienceStoreLiquorStoreGasStation = 'CONVENIENCE_STORE__LIQUOR_STORE__GAS_STATION',
  CustomerServiceAndSupport = 'CUSTOMER_SERVICE_AND_SUPPORT',
  Education = 'EDUCATION',
  EmbassyConsulate = 'EMBASSY__CONSULATE',
  Energy = 'ENERGY',
  Engineering = 'ENGINEERING',
  FashionClothing = 'FASHION__CLOTHING',
  FinancialServices = 'FINANCIAL_SERVICES',
  FirearmsAndExplosives = 'FIREARMS_AND_EXPLOSIVES',
  GamingCasinoCardClub = 'GAMING__CASINO__CARD_CLUB',
  GovernmentPublicAdministration = 'GOVERNMENT__PUBLIC_ADMINISTRATION',
  GrocerySupermarket = 'GROCERY__SUPERMARKET',
  HealthcareMedicalServices = 'HEALTHCARE__MEDICAL_SERVICES',
  HotelHospitality = 'HOTEL__HOSPITALITY',
  ImportExport = 'IMPORT__EXPORT',
  IndustryNotApplicableUnemployed = 'INDUSTRY__NOT__APPLICABLE__UNEMPLOYED',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  Insurance = 'INSURANCE',
  JewelryGemsAndPreciousMetals = 'JEWELRY_GEMS_AND_PRECIOUS_METALS',
  LegalServicesPublicSafety = 'LEGAL_SERVICES__PUBLIC_SAFETY',
  LogisticsSupplyChain = 'LOGISTICS__SUPPLY_CHAIN',
  Manufacturing = 'MANUFACTURING',
  Maritime = 'MARITIME',
  MediaEntertainment = 'MEDIA__ENTERTAINMENT',
  MiningOilAndGas = 'MINING_OIL_AND_GAS',
  MoneyServicesBusinesses = 'MONEY_SERVICES_BUSINESSES',
  NonProfitNgoCharity = 'NON_PROFIT__NGO__CHARITY',
  OtherIndustry = 'OTHER_INDUSTRY',
  ParkingAndCarWashes = 'PARKING_AND_CAR_WASHES',
  PawnShopsBrokers = 'PAWN_SHOPS__BROKERS',
  PersonalCareHygiene = 'PERSONAL_CARE__HYGIENE',
  Pharmaceuticals = 'PHARMACEUTICALS',
  PrintingPublishing = 'PRINTING__PUBLISHING',
  ProfessionalCivicOrganizations = 'PROFESSIONAL__CIVIC_ORGANIZATIONS',
  RealEstate = 'REAL_ESTATE',
  ReligiousOrganization = 'RELIGIOUS_ORGANIZATION',
  RepairServices = 'REPAIR_SERVICES',
  RestaurantFoodService = 'RESTAURANT__FOOD_SERVICE',
  RetailSalesRetailTrade = 'RETAIL_SALES__RETAIL_TRADE',
  Retirement = 'RETIREMENT',
  ScienceAndBiotechnology = 'SCIENCE_AND_BIOTECHNOLOGY',
  Security = 'SECURITY',
  Transportation = 'TRANSPORTATION',
  Travel = 'TRAVEL',
  Utilities = 'UTILITIES',
  WholesaleSalesTrade = 'WHOLESALE_SALES__TRADE'
}

export enum OccupationTitle {
  AccountantAuditorBookkeeper = 'ACCOUNTANT__AUDITOR__BOOKKEEPER',
  Adjuster = 'ADJUSTER',
  AdvertiserMarketerPrProfessional = 'ADVERTISER__MARKETER__PR_PROFESSIONAL',
  AirTrafficController = 'AIR_TRAFFIC_CONTROLLER',
  AmbassadorConsulateProfessional = 'AMBASSADOR__CONSULATE_PROFESSIONAL',
  Analyst = 'ANALYST',
  Appraiser = 'APPRAISER',
  ArchitectDesigner = 'ARCHITECT__DESIGNER',
  ArtistPerformerActorDancer = 'ARTIST__PERFORMER__ACTOR__DANCER',
  AssistantExecutiveAssistant = 'ASSISTANT__EXECUTIVE_ASSISTANT',
  Athlete = 'ATHLETE',
  AttorneyJudgeLegalProfessional = 'ATTORNEY__JUDGE__LEGAL_PROFESSIONAL',
  Auctioneer = 'AUCTIONEER',
  BankerLendingProfessional = 'BANKER__LENDING_PROFESSIONAL',
  BarberBeauticianHairstylist = 'BARBER__BEAUTICIAN__HAIRSTYLIST',
  BrokerRegisteredRep = 'BROKER__REGISTERED_REP',
  BusinessExecutive = 'BUSINESS_EXECUTIVE',
  BusinessOwner = 'BUSINESS_OWNER',
  Caregiver = 'CAREGIVER',
  CarpenterConstructionWorkerContractor = 'CARPENTER__CONSTRUCTION_WORKER__CONTRACTOR',
  Cashier = 'CASHIER',
  ChefCook = 'CHEF__COOK',
  Chiropractor = 'CHIROPRACTOR',
  CivilServant = 'CIVIL_SERVANT',
  Clergy = 'CLERGY',
  Clerk = 'CLERK',
  ComplianceRegulatoryProfessional = 'COMPLIANCE__REGULATORY_PROFESSIONAL',
  Consultant = 'CONSULTANT',
  CounselorTherapist = 'COUNSELOR__THERAPIST',
  CustomerServiceRepresentative = 'CUSTOMER_SERVICE_REPRESENTATIVE',
  Dealer = 'DEALER',
  Dentist = 'DENTIST',
  Distributor = 'DISTRIBUTOR',
  DoctorSurgeonPhysician = 'DOCTOR__SURGEON__PHYSICIAN',
  Driver = 'DRIVER',
  Engineer = 'ENGINEER',
  Exterminator = 'EXTERMINATOR',
  FactoryWarehouseWorker = 'FACTORY__WAREHOUSE_WORKER',
  FarmerRancher = 'FARMER__RANCHER',
  FinancialPlannerAdvisor = 'FINANCIAL_PLANNER__ADVISOR',
  FlightAttendant = 'FLIGHT_ATTENDANT',
  HumanResourcesProfessional = 'HUMAN_RESOURCES_PROFESSIONAL',
  ImporterExporter = 'IMPORTER__EXPORTER',
  InspectorInvestigator = 'INSPECTOR__INVESTIGATOR',
  Investor = 'INVESTOR',
  ItProfessionalItAssociate = 'IT_PROFESSIONAL__IT_ASSOCIATE',
  Janitor = 'JANITOR',
  Jeweler = 'JEWELER',
  Laborer = 'LABORER',
  Landscaper = 'LANDSCAPER',
  Mechanic = 'MECHANIC',
  MilitaryOfficerOrAssociated = 'MILITARY_OFFICER_OR_ASSOCIATED',
  MorticianFuneralDirector = 'MORTICIAN__FUNERAL_DIRECTOR',
  Nurse = 'NURSE',
  OfficeAssociate = 'OFFICE_ASSOCIATE',
  Pharmacist = 'PHARMACIST',
  PhysicalTherapist = 'PHYSICAL_THERAPIST',
  Pilot = 'PILOT',
  PoliceOfficerFirefighterLawEnforcementProfessional = 'POLICE_OFFICER__FIREFIGHTER__LAW_ENFORCEMENT_PROFESSIONAL',
  Politician = 'POLITICIAN',
  ProjectManager = 'PROJECT_MANAGER',
  RealEstateProfessional = 'REAL_ESTATE_PROFESSIONAL',
  Researcher = 'RESEARCHER',
  Salesperson = 'SALESPERSON',
  Scientist = 'SCIENTIST',
  SeamstressTailor = 'SEAMSTRESS__TAILOR',
  SecurityGuard = 'SECURITY_GUARD',
  SocialWorker = 'SOCIAL_WORKER',
  TeacherProfessor = 'TEACHER__PROFESSOR',
  Technician = 'TECHNICIAN',
  Teller = 'TELLER',
  TitleNotApplicableUnemployed = 'TITLE__NOT__APPLICABLE__UNEMPLOYED',
  TradespersonCraftsperson = 'TRADESPERSON__CRAFTSPERSON',
  TrainerInstructor = 'TRAINER__INSTRUCTOR',
  Underwriter = 'UNDERWRITER',
  Veterinarian = 'VETERINARIAN',
  WriterJournalistEditor = 'WRITER__JOURNALIST__EDITOR'
}

export type Partner = {
  accountType?: Maybe<AccountType>;
  beneficiaryFirstName?: Maybe<Scalars['String']['output']>;
  beneficiaryLastName?: Maybe<Scalars['String']['output']>;
  contributionsInCents?: Maybe<Scalars['Float']['output']>;
  currentAmountInCents?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  recurringDepositInCents?: Maybe<Scalars['Float']['output']>;
  recurringDepositSchedule?: Maybe<SipFrequency>;
};

export type PartnerGoalContributions = {
  contributionsInCents?: Maybe<Scalars['Float']['output']>;
  partnerFirstName?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerLastName?: Maybe<Scalars['String']['output']>;
  recurringDepositInCents?: Maybe<Scalars['Int']['output']>;
  recurringDepositSchedule?: Maybe<SipFrequency>;
};

export enum PartnerType {
  IntegrationDirect = 'INTEGRATION_DIRECT',
  IntegrationWhitelabel = 'INTEGRATION_WHITELABEL',
  LeadGenerator = 'LEAD_GENERATOR'
}

export type PauseRecurringDepositInput = {
  sipId: Scalars['String']['input'];
};

export enum PlanOption {
  GenerationsAnnually = 'GENERATIONS_ANNUALLY',
  GenerationsMonthly = 'GENERATIONS_MONTHLY',
  ProAnnually = 'PRO_ANNUALLY',
  ProMonthly = 'PRO_MONTHLY',
  Starter = 'STARTER'
}

export enum PortfolioAssetExposureNames {
  Alternative = 'ALTERNATIVE',
  Bond = 'BOND',
  Cash = 'CASH',
  CommonStock = 'COMMON_STOCK',
  Crypto = 'CRYPTO',
  ExchangeTradedProduct = 'EXCHANGE_TRADED_PRODUCT',
  ForeignBond = 'FOREIGN_BOND',
  ForeignStock = 'FOREIGN_STOCK',
  MutualFund = 'MUTUAL_FUND',
  Option = 'OPTION',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE'
}

export type PortfolioBreakdown = {
  assetClassExposures?: Maybe<Array<Maybe<AssetClassExposure>>>;
  /** @deprecated Use netInvestmentsInCents instead */
  contributionsInCents?: Maybe<Scalars['Float']['output']>;
  netInvestmentsInCents?: Maybe<Scalars['Float']['output']>;
  returnsInCents?: Maybe<Scalars['Float']['output']>;
  sectorExposures?: Maybe<Array<Maybe<SectorExposure>>>;
  totalValueInCents?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioBreakdownInput = {
  /** @deprecated Use goalId instead */
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['String']['input']>;
};

export type PortfolioPerformanceGraph = {
  grossReturnAbsolute?: Maybe<Scalars['Float']['output']>;
  grossReturnPercentage?: Maybe<Scalars['Float']['output']>;
  nodes?: Maybe<Array<Maybe<PortfolioPerformanceGraphNode>>>;
};

export type PortfolioPerformanceGraphInput = {
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['String']['input']>;
  nodeCount?: InputMaybe<Scalars['Int']['input']>;
  timeFrame: PortfolioPerformanceGraphTimeFrame;
};

export type PortfolioPerformanceGraphNode = {
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export enum PortfolioPerformanceGraphTimeFrame {
  FiveYear = 'FIVE_YEAR',
  OneDay = 'ONE_DAY',
  OneMonth = 'ONE_MONTH',
  OneWeek = 'ONE_WEEK',
  OneYear = 'ONE_YEAR',
  SixMonth = 'SIX_MONTH',
  TenYear = 'TEN_YEAR',
  ThreeMonth = 'THREE_MONTH'
}

export type PortfolioPosition = {
  changeTodayAmountInCents?: Maybe<Scalars['Float']['output']>;
  changeTodayPercentage?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  sharePriceInCents: Scalars['Float']['output'];
  shares: Scalars['Float']['output'];
  symbol: Scalars['String']['output'];
  totalValueInCents: Scalars['Float']['output'];
};

export type PortfolioPositionsInput = {
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['String']['input']>;
};

export enum PortfolioSectorExposureNames {
  BusinessServices = 'BUSINESS_SERVICES',
  CommunicationServices = 'COMMUNICATION_SERVICES',
  ConsumerDiscretionary = 'CONSUMER_DISCRETIONARY',
  ConsumerServices = 'CONSUMER_SERVICES',
  ConsumerStaples = 'CONSUMER_STAPLES',
  Crypto = 'CRYPTO',
  Energy = 'ENERGY',
  Etf = 'ETF',
  Fiat = 'FIAT',
  Financials = 'FINANCIALS',
  FixedIncome = 'FIXED_INCOME',
  HealthCare = 'HEALTH_CARE',
  Industrials = 'INDUSTRIALS',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  Materials = 'MATERIALS',
  MoneyMarket = 'MONEY_MARKET',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE',
  Utilities = 'UTILITIES'
}

export type ProcessPublicTokenInput = {
  institutionId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};

export type PromotionCode = {
  active?: Maybe<Scalars['Boolean']['output']>;
  amountOff?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
  redemptionText?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  /** @deprecated Use input instead of individual arguments */
  account?: Maybe<Array<Account>>;
  addressDetails?: Maybe<AddressDetails>;
  addressPredictions?: Maybe<AddressPredictions>;
  availableToWithdrawInCents: AvailableToWithdrawInCentsOutput;
  beneficiaries?: Maybe<Array<Maybe<Beneficiary>>>;
  beneficiaryGiftingLink?: Maybe<BeneficiaryGiftingLink>;
  businessAddress?: Maybe<BusinessAddress>;
  checkGiftingCodeAvailability?: Maybe<CheckGiftingCodeAvailabilityOutput>;
  checkHalfmoreAvailability: CheckHalfmoreAvailabilityOutput;
  /** Every consent the caller has signed, newest first. */
  consents: Array<Consent>;
  countries?: Maybe<Scalars['JSON']['output']>;
  /** The agreement version currently in force for a type, or null if none is. */
  currentAgreement?: Maybe<Agreement>;
  /** Get current supported version */
  currentVersion?: Maybe<Scalars['String']['output']>;
  defaultProjectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  document: Document;
  documentTypes: Array<DocumentTypeInfo>;
  documents: Array<Document>;
  failedAchContribution?: Maybe<FailedAchContribution>;
  featureFlags: Array<FeatureFlag>;
  getBankAccounts?: Maybe<Array<BankAccount>>;
  getBankLinkToken?: Maybe<GetBankLinkTokenPayload>;
  getBankLinks?: Maybe<Array<Maybe<BankLink>>>;
  /** Get the latest shake streak for the user */
  getCurrentStreak?: Maybe<ShakeStreak>;
  /** Get the entries of the week for the user */
  getCurrentWeekEntries?: Maybe<WeekEntries>;
  getHalfmoreRedirection?: Maybe<GetHalfmoreRedirectionOutput>;
  /** Get the squad that the user is currently joined */
  getJoinedSquad?: Maybe<SquadWithMembers>;
  getSubscription?: Maybe<Subscription>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  harvestAccountDefaultConfigs?: Maybe<HarvestAccountConfigs>;
  hasScheduledContributions: HasScheduledContributionsOutput;
  industries?: Maybe<Scalars['JSON']['output']>;
  /** Check if input version is supported or not */
  isSupportedVersion?: Maybe<Scalars['Boolean']['output']>;
  isUserOnWaitlist?: Maybe<Scalars['Boolean']['output']>;
  isWithdrawalAllowed: IsWithdrawalAllowedOutput;
  occupations?: Maybe<Scalars['JSON']['output']>;
  portfolioBreakdown: PortfolioBreakdown;
  portfolioPerformanceGraph: PortfolioPerformanceGraph;
  portfolioPositions: Array<Maybe<PortfolioPosition>>;
  promotionalDollarBalanceInCents: Scalars['Int']['output'];
  receivedGifts?: Maybe<Array<Maybe<GiftingIntent>>>;
  receivedShareGoalInvites?: Maybe<Array<Maybe<ReceivedShareGoalInvite>>>;
  reserveInterestRate: ReserveInterestRateResult;
  sentShareGoalInvites?: Maybe<Array<Maybe<SentShareGoalInvite>>>;
  suggestedAccountType: SuggestedAccountTypeResult;
  transactions?: Maybe<TransactionQueryResponse>;
  user?: Maybe<User>;
  userKYCCompletionLink?: Maybe<Scalars['String']['output']>;
  userPrefillData?: Maybe<UserPrefillData>;
  userProfileClosureStatus?: Maybe<UserProfileClosureStatus>;
  userPromotionCodeRedemptions?: Maybe<Array<Maybe<UserPromotionCodeRedemption>>>;
  userReferralData?: Maybe<UserReferralData>;
};


export type QueryAccountArgs = {
  childId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<AccountInput>;
  type?: InputMaybe<AccountType>;
};


export type QueryAddressDetailsArgs = {
  placeId: Scalars['String']['input'];
};


export type QueryAddressPredictionsArgs = {
  input: Scalars['String']['input'];
};


export type QueryAvailableToWithdrawInCentsArgs = {
  input: AvailableToWithdrawInCentsInput;
};


export type QueryBeneficiariesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBeneficiaryGiftingLinkArgs = {
  beneficiaryId: Scalars['String']['input'];
};


export type QueryBusinessAddressArgs = {
  input: Scalars['String']['input'];
};


export type QueryCheckGiftingCodeAvailabilityArgs = {
  input: CheckGiftingCodeAvailabilityInput;
};


export type QueryCurrentAgreementArgs = {
  input: CurrentAgreementInput;
};


export type QueryDefaultProjectedRateOfReturnArgs = {
  input: DefaultProjectedRateOfReturnInput;
};


export type QueryDocumentArgs = {
  input: DocumentInput;
};


export type QueryDocumentsArgs = {
  input: DocumentsInput;
};


export type QueryGetBankLinkTokenArgs = {
  input?: InputMaybe<GetBankLinkTokenInput>;
};


export type QueryGoalsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHarvestAccountDefaultConfigsArgs = {
  input: HarvestAccountDefaultConfigsInput;
};


export type QueryIsSupportedVersionArgs = {
  version: Scalars['String']['input'];
};


export type QueryIsWithdrawalAllowedArgs = {
  input: IsWithdrawalAllowedInput;
};


export type QueryPortfolioBreakdownArgs = {
  input: PortfolioBreakdownInput;
};


export type QueryPortfolioPerformanceGraphArgs = {
  input: PortfolioPerformanceGraphInput;
};


export type QueryPortfolioPositionsArgs = {
  input: PortfolioPositionsInput;
};


export type QueryReserveInterestRateArgs = {
  input: ReserveInterestRateInput;
};


export type QuerySentShareGoalInvitesArgs = {
  goalId: Scalars['String']['input'];
};


export type QuerySuggestedAccountTypeArgs = {
  input: SuggestedAccountTypeInput;
};


export type QueryTransactionsArgs = {
  input: TransactionsInput;
};

export type ReceivedShareGoalInvite = {
  beneficiaryType?: Maybe<BeneficiaryType>;
  contributionsAfter18?: Maybe<Scalars['Boolean']['output']>;
  contributionsInCents?: Maybe<Scalars['Float']['output']>;
  currentAmountInCents?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  expiry?: Maybe<Scalars['DateTime']['output']>;
  goalName?: Maybe<Scalars['String']['output']>;
  goalType?: Maybe<GoalType>;
  id?: Maybe<Scalars['String']['output']>;
  inviterFirstName?: Maybe<Scalars['String']['output']>;
  inviterLastName?: Maybe<Scalars['String']['output']>;
  partnerGoalContributions?: Maybe<Array<Maybe<PartnerGoalContributions>>>;
  projectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  recurringDepositInCents?: Maybe<Scalars['Int']['output']>;
  recurringDepositSchedule?: Maybe<SipFrequency>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ShareGoalInviteStatus>;
  targetAmountInCents?: Maybe<Scalars['Float']['output']>;
  targetYear?: Maybe<Scalars['Int']['output']>;
};

export type RefreshTokenInput = {
  token: Scalars['String']['input'];
};

export type RegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  promotionCode?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterWithPhoneInput = {
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  promotionCode?: InputMaybe<Scalars['String']['input']>;
};

export type RemovePartnerFromGoalInput = {
  goalId: Scalars['String']['input'];
  partnerId: Scalars['String']['input'];
};

export type RemoveSquadMemberInput = {
  userId: Scalars['String']['input'];
};

export type ResendInviteToShareGoalInput = {
  shareGoalInviteId: Scalars['String']['input'];
};

export type ReserveInterestRateInput = {
  annualIncome: UserAnnualIncome;
  state: Scalars['String']['input'];
};

export type ReserveInterestRateResult = {
  baseRateBps: Scalars['Int']['output'];
  iraMatchBonusBps: Scalars['Int']['output'];
  teyRateBps: Scalars['Int']['output'];
  welcomeBoostBps: Scalars['Int']['output'];
};

export type ResetPasswordInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ResumeRecurringDepositInput = {
  sipId: Scalars['String']['input'];
};

export enum RiskScore {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  One = 'ONE',
  Seven = 'SEVEN',
  Six = 'SIX',
  Ten = 'TEN',
  Three = 'THREE',
  Two = 'TWO'
}

export type SectorExposure = {
  factorPercentage: Scalars['Float']['output'];
  name: PortfolioSectorExposureNames;
};

export type SentShareGoalInvite = {
  expiry?: Maybe<Scalars['DateTime']['output']>;
  goalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ShareGoalInviteStatus>;
};

export type SetUserFinancialProfile = {
  annualIncome?: InputMaybe<UserAnnualIncome>;
  downturnReaction?: InputMaybe<UserDownturnReaction>;
  employerAddressCity?: InputMaybe<Scalars['String']['input']>;
  employerAddressCountry?: InputMaybe<Scalars['String']['input']>;
  employerAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  employerAddressState?: InputMaybe<Scalars['String']['input']>;
  employerAddressStreet?: InputMaybe<Scalars['String']['input']>;
  employerAddressUnitNo?: InputMaybe<Scalars['String']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<UserEmploymentStatus>;
  investmentHorizon?: InputMaybe<UserInvestmentHorizon>;
  investmentPriority?: InputMaybe<UserInvestmentPriority>;
  isControlPerson?: InputMaybe<Scalars['Boolean']['input']>;
  isFamilyPoliticallyExposed?: InputMaybe<Scalars['Boolean']['input']>;
  isFinraAffiliated?: InputMaybe<Scalars['Boolean']['input']>;
  isPoliticallyExposed?: InputMaybe<Scalars['Boolean']['input']>;
  liquidNetWorth?: InputMaybe<UserLiquidNetWorth>;
  occupationIndustry?: InputMaybe<OccupationIndustry>;
  occupationTitle?: InputMaybe<OccupationTitle>;
  sourceOfFunds?: InputMaybe<UserSourceOfFunds>;
  trustedContactAddressCity?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressCountry?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressState?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressStreet?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressUnitNo?: InputMaybe<Scalars['String']['input']>;
  trustedContactEmail?: InputMaybe<Scalars['String']['input']>;
  trustedContactFirstName?: InputMaybe<Scalars['String']['input']>;
  trustedContactLastName?: InputMaybe<Scalars['String']['input']>;
  trustedContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SetUserIdentity = {
  address?: InputMaybe<UserAddressInput>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  countryOfCitizenship?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<UserMaritalStatus>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use registerUser mutation with promotionCode instead */
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  residenceStatus?: InputMaybe<UserResidenceStatus>;
  spouseDateOfBirth?: InputMaybe<Scalars['String']['input']>;
  spouseFirstName?: InputMaybe<Scalars['String']['input']>;
  spouseLastName?: InputMaybe<Scalars['String']['input']>;
  visaExpirationDate?: InputMaybe<Scalars['String']['input']>;
  visaStatus?: InputMaybe<UserVisaStatus>;
};

export type SetUserTaxProfile = {
  countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  stateOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  taxId: Scalars['String']['input'];
  taxIdType?: InputMaybe<UserTaxIdType>;
};

export type SetUserTrustedContact = {
  trustedContactAddressCity?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressCountry?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressState?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressStreet?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressUnitNo?: InputMaybe<Scalars['String']['input']>;
  trustedContactEmail?: InputMaybe<Scalars['String']['input']>;
  trustedContactFirstName?: InputMaybe<Scalars['String']['input']>;
  trustedContactLastName?: InputMaybe<Scalars['String']['input']>;
  trustedContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Settings = {
  accountClosureEnabled: Scalars['Boolean']['output'];
  achConnectYourBankReLinkPopUp: Scalars['Boolean']['output'];
  achContributionFailedBankReLinkPopUp: Scalars['Boolean']['output'];
  achContributionNotProcessedBankReLinkPopUp: Scalars['Boolean']['output'];
  achUnauthorizedPopUp: Scalars['Boolean']['output'];
  capitalGroupMigrationEnabled: Scalars['Boolean']['output'];
  capitalGroupMigrationInProgress: Scalars['Boolean']['output'];
  capitalGroupMigrationOverride: Scalars['Boolean']['output'];
  contributionsManagedExternally: Scalars['Boolean']['output'];
  documentsPortalEnabled: Scalars['Boolean']['output'];
  giftingEnabled: Scalars['Boolean']['output'];
  mandateBankRelink: Scalars['Boolean']['output'];
  oneTimeContributionsEnabled: Scalars['Boolean']['output'];
  plaidRelinkBannerEnabled: Scalars['Boolean']['output'];
  promotionCodeEnabled: Scalars['Boolean']['output'];
  promotionFundsAllocationEnabled: Scalars['Boolean']['output'];
  promotionFundsAllocationSupportMessageEnabled: Scalars['Boolean']['output'];
  recurringContributionsEnabled: Scalars['Boolean']['output'];
  referralsEnabled: Scalars['Boolean']['output'];
  withdrawalsEnabled: Scalars['Boolean']['output'];
};

export type ShakeStreak = {
  createdAt: Scalars['DateTime']['output'];
  currentWeekShakeStatus: CurrentWeekShakeStatus;
  hasShakenToday: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  status: ShakeStreakStatus;
  streakCount: Scalars['Int']['output'];
  streakEnd?: Maybe<Scalars['DateTime']['output']>;
  streakStart: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum ShakeStreakStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED'
}

export enum ShareGoalInviteAction {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export enum ShareGoalInviteStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Sip = {
  id?: Maybe<Scalars['String']['output']>;
  isPendingFundingSource?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use status instead of paused */
  paused?: Maybe<Scalars['Boolean']['output']>;
  recurringDepositInCents?: Maybe<Scalars['Int']['output']>;
  recurringDepositSchedule?: Maybe<SipFrequency>;
  status?: Maybe<SipStatus>;
};

export enum SipFrequency {
  Annually = 'ANNUALLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum SipStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Modifying = 'MODIFYING',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  Paused = 'PAUSED'
}

export type Squad = {
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  isAdmin: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SquadMember = {
  createdAt: Scalars['DateTime']['output'];
  hasShaken: Scalars['Boolean']['output'];
  squadId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userDisplayName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SquadWithMembers = {
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  isAdmin: Scalars['Boolean']['output'];
  members: Array<Maybe<SquadMember>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Subaccount = {
  balanceInCents?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<RiskScore>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SubaccountType>;
};

export enum SubaccountType {
  CustomIndexing = 'CUSTOM_INDEXING',
  CustomPortfolio = 'CUSTOM_PORTFOLIO',
  PromotionalDollars = 'PROMOTIONAL_DOLLARS',
  SelfDirected = 'SELF_DIRECTED'
}

export type SubmitUserFeedbackInput = {
  feedback: Scalars['String']['input'];
};

export type Subscription = {
  assetThresholdPercent: Scalars['Float']['output'];
  billingInterval: BillingInterval;
  createdAt: Scalars['DateTime']['output'];
  hasReachedAssetThreshold: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  nextBillingDate: Scalars['DateTime']['output'];
  plan: SubscriptionPlan;
  status: SubscriptionStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SubscriptionPlan {
  Generations = 'GENERATIONS',
  Pro = 'PRO',
  Starter = 'STARTER'
}

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type SuggestedAccountTypeInput = {
  beneficiaryDateOfBirth?: InputMaybe<Scalars['DateOfBirth']['input']>;
  flexibilityPreference?: InputMaybe<FlexibilityPreference>;
  goalTargetAmountInCents?: InputMaybe<Scalars['Float']['input']>;
  goalType: GoalType;
  isSharedGoal?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  weeklyDepositInCents?: InputMaybe<Scalars['Int']['input']>;
  who: SuggestedAccountWho;
};

export type SuggestedAccountTypeResult = {
  alternatives: Array<AccountType>;
  recommended: AccountType;
};

export enum SuggestedAccountWho {
  Child = 'CHILD',
  Myself = 'MYSELF',
  Together = 'TOGETHER'
}

export enum SupportedCurrenciesEnum {
  Cad = 'CAD',
  Usd = 'USD'
}

export type Transaction = {
  amountInCents?: Maybe<Scalars['Int']['output']>;
  beneficiaryId?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedCompletionDateRange?: Maybe<Scalars['String']['output']>;
  goalId?: Maybe<Scalars['String']['output']>;
  goalName?: Maybe<Scalars['String']['output']>;
  goalType?: Maybe<GoalType>;
  id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use type instead of label */
  label?: Maybe<TransactionLabel>;
  processingDate?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  scheduledDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TransactionStatus>;
  subscriptionPeriod?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TransactionType>;
};

export enum TransactionLabel {
  Adjustment = 'ADJUSTMENT',
  Deposit = 'DEPOSIT',
  Fee = 'FEE',
  Interest = 'INTEREST',
  Reward = 'REWARD',
  Withdrawal = 'WITHDRAWAL'
}

export type TransactionQueryResponse = {
  elements: Array<Maybe<Transaction>>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export enum TransactionStatus {
  Cancelled = 'CANCELLED',
  Committed = 'COMMITTED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  MfaRequired = 'MFA_REQUIRED',
  New = 'NEW',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  TradeInitiated = 'TRADE_INITIATED'
}

export enum TransactionTime {
  Past = 'PAST',
  Pending = 'PENDING',
  Upcoming = 'UPCOMING'
}

export enum TransactionType {
  Adjustment = 'ADJUSTMENT',
  Contribution = 'CONTRIBUTION',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Dividend = 'DIVIDEND',
  Fee = 'FEE',
  Gifting = 'GIFTING',
  Interest = 'INTEREST',
  Journal = 'JOURNAL',
  OneTimeContribution = 'ONE_TIME_CONTRIBUTION',
  RecurringContribution = 'RECURRING_CONTRIBUTION',
  Reversal = 'REVERSAL',
  Reward = 'REWARD',
  SubscriptionFee = 'SUBSCRIPTION_FEE',
  Tax = 'TAX',
  Transfer = 'TRANSFER',
  Withdrawal = 'WITHDRAWAL',
  WithdrawalAll = 'WITHDRAWAL_ALL'
}

export type TransactionsInput = {
  /** @deprecated Field will be deprecated in the next release */
  accountId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Field will be deprecated in the next release */
  subaccountId?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<TransactionTime>;
};

export enum TrumpContributionFrequency {
  Annually = 'ANNUALLY',
  BiWeekly = 'BI_WEEKLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum UsStateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type UpdateBeneficiaryGiftingCodeInput = {
  beneficiaryId: Scalars['String']['input'];
  newGiftingCode: Scalars['String']['input'];
};

export type UpdateBeneficiaryGiftingCodeOutput = {
  giftingCode: Scalars['String']['output'];
  giftingUrl: Scalars['String']['output'];
  isGiftingCodeConfirmed: Scalars['Boolean']['output'];
};

export type UpdateBeneficiaryInput = {
  beneficiaryId: Scalars['String']['input'];
  countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateOfBirth']['input']>;
  dueDate?: InputMaybe<Scalars['DateOfBirth']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  incomeAt18?: InputMaybe<IncomeAt18>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<BeneficiaryRelationship>;
  stateOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<UserTaxIdType>;
};

export type UpdateHarvestAccountConfigsInput = {
  accountId: Scalars['String']['input'];
  harvestLongTermCapitalGains?: InputMaybe<Scalars['Boolean']['input']>;
  harvestRecommendedFloorUsd?: InputMaybe<Scalars['Int']['input']>;
  harvestStandardDeduction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSquadInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  squadId: Scalars['String']['input'];
};

export type UpdateSubscriptionInput = {
  planOption: PlanOption;
};

export type User = {
  accounts?: Maybe<Array<Maybe<Account>>>;
  bankLink?: Maybe<Array<Maybe<BankLink>>>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  countryOfCitizenship?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['DateOfBirth']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<UserLanguage>;
  lastName?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<UserMaritalStatus>;
  partner?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerOnboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  partnerType?: Maybe<PartnerType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerified?: Maybe<Scalars['Boolean']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<AccountProvider>;
  residenceStatus?: Maybe<UserResidenceStatus>;
  settings?: Maybe<Settings>;
  /** @deprecated Now sourced from settings.capitalGroupMigrationInProgress. Use that field directly. */
  showAccountMigrationInProgressBanner?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The Altruist migration is complete and this is now always false. Kept so released mobile builds that still select it keep validating. */
  showMigrationFlow?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<UserStatus>;
  termsAccepted?: Maybe<Scalars['Boolean']['output']>;
  tradeConfirmationsAgreementAccepted?: Maybe<Scalars['Boolean']['output']>;
  userAddress?: Maybe<UserAddress>;
  userFinancialProfile?: Maybe<UserFinancialProfile>;
  userTaxProfiles?: Maybe<Array<Maybe<UserTaxProfile>>>;
  visaExpirationDate?: Maybe<Scalars['String']['output']>;
  visaStatus?: Maybe<UserVisaStatus>;
};

export type UserAddress = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** @deprecated No use for the field */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  unitNo?: Maybe<Scalars['String']['output']>;
  /** @deprecated No use for the field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  unitNo?: InputMaybe<Scalars['String']['input']>;
};

export enum UserAnnualIncome {
  Between_100000And_250000 = 'BETWEEN_100000_AND_250000',
  Between_250000And_500000 = 'BETWEEN_250000_AND_500000',
  LessThan_100000 = 'LESS_THAN_100000',
  MoreThan_500000 = 'MORE_THAN_500000'
}

export enum UserDownturnReaction {
  Buy = 'BUY',
  Hold = 'HOLD',
  Sell = 'SELL'
}

export enum UserEmploymentStatus {
  Employed = 'EMPLOYED',
  HomeMaker = 'HOME_MAKER',
  Retired = 'RETIRED',
  SelfEmployed = 'SELF_EMPLOYED',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED'
}

export type UserFinancialProfile = {
  annualIncome?: Maybe<UserAnnualIncome>;
  /** @deprecated No use for the field */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  downturnReaction?: Maybe<UserDownturnReaction>;
  employerAddressCity?: Maybe<Scalars['String']['output']>;
  employerAddressCountry?: Maybe<Scalars['String']['output']>;
  employerAddressPostalCode?: Maybe<Scalars['String']['output']>;
  employerAddressState?: Maybe<Scalars['String']['output']>;
  employerAddressStreet?: Maybe<Scalars['String']['output']>;
  employerAddressUnitNo?: Maybe<Scalars['String']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<UserEmploymentStatus>;
  id?: Maybe<Scalars['String']['output']>;
  investmentHorizon?: Maybe<UserInvestmentHorizon>;
  investmentPriority?: Maybe<UserInvestmentPriority>;
  isControlPerson?: Maybe<Scalars['Boolean']['output']>;
  isFamilyPoliticallyExposed?: Maybe<Scalars['Boolean']['output']>;
  isFinraAffiliated?: Maybe<Scalars['Boolean']['output']>;
  isPoliticallyExposed?: Maybe<Scalars['Boolean']['output']>;
  liquidNetWorth?: Maybe<UserLiquidNetWorth>;
  occupationIndustry?: Maybe<OccupationIndustry>;
  occupationTitle?: Maybe<OccupationTitle>;
  sourceOfFunds?: Maybe<UserSourceOfFunds>;
  trustedContactAddressCity?: Maybe<Scalars['String']['output']>;
  trustedContactAddressCountry?: Maybe<Scalars['String']['output']>;
  trustedContactAddressPostalCode?: Maybe<Scalars['String']['output']>;
  trustedContactAddressState?: Maybe<Scalars['String']['output']>;
  trustedContactAddressStreet?: Maybe<Scalars['String']['output']>;
  trustedContactAddressUnitNo?: Maybe<Scalars['String']['output']>;
  trustedContactEmail?: Maybe<Scalars['String']['output']>;
  trustedContactFirstName?: Maybe<Scalars['String']['output']>;
  trustedContactLastName?: Maybe<Scalars['String']['output']>;
  trustedContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated No use for the field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserGovernmentId = {
  country?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserGovernmentIdType>;
};

export enum UserGovernmentIdType {
  DriversLicense = 'DRIVERS_LICENSE',
  IdentificationCard = 'IDENTIFICATION_CARD',
  Passport = 'PASSPORT',
  TaxId = 'TAX_ID'
}

export enum UserInvestmentHorizon {
  LongTerm = 'LONG_TERM',
  MediumTerm = 'MEDIUM_TERM',
  ShortTerm = 'SHORT_TERM'
}

export enum UserInvestmentPriority {
  AvoidLosses = 'AVOID_LOSSES',
  BalanceRisk = 'BALANCE_RISK',
  MaximizeReturns = 'MAXIMIZE_RETURNS'
}

export enum UserLanguage {
  EnUs = 'EN_US'
}

export enum UserLiquidNetWorth {
  Between_100000And_250000 = 'BETWEEN_100000_AND_250000',
  Between_250000And_500000 = 'BETWEEN_250000_AND_500000',
  LessThan_100000 = 'LESS_THAN_100000',
  MoreThan_500000 = 'MORE_THAN_500000'
}

export enum UserMaritalStatus {
  Married = 'MARRIED',
  Single = 'SINGLE'
}

export type UserPrefillData = {
  address?: Maybe<UserAddress>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
};

export type UserProfileClosureStatus = {
  initiatedAt?: Maybe<Scalars['DateTime']['output']>;
  isUserEligibleForRetentionCode: Scalars['Boolean']['output'];
  status: UserStatus;
  userId: Scalars['String']['output'];
  withdrawalTimeline?: Maybe<Scalars['DateTime']['output']>;
};

export type UserPromotionCodeRedemption = {
  id: Scalars['String']['output'];
  promotionCode: PromotionCode;
  status: UserPromotionCodeStatus;
};

export enum UserPromotionCodeStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  New = 'NEW',
  Processing = 'PROCESSING'
}

export type UserReferral = {
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  amountInCents?: Maybe<Scalars['Int']['output']>;
  contributedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  signedUpAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<UserReferralStatus>;
};

export type UserReferralData = {
  earnedBonusInCents: Scalars['Int']['output'];
  inviteText: Scalars['String']['output'];
  pendingBonusInCents: Scalars['Int']['output'];
  referralAmountInCents?: Maybe<Scalars['Int']['output']>;
  referralUrl: Scalars['String']['output'];
  referrals: Array<Maybe<UserReferral>>;
};

export enum UserReferralStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  New = 'NEW',
  Processing = 'PROCESSING'
}

export enum UserResidenceStatus {
  Citizen = 'CITIZEN',
  None = 'NONE',
  NonResident = 'NON_RESIDENT',
  Resident = 'RESIDENT'
}

export enum UserSourceOfFunds {
  BusinessIncome = 'BUSINESS_INCOME',
  EmploymentIncome = 'EMPLOYMENT_INCOME',
  Family = 'FAMILY',
  Inheritance = 'INHERITANCE',
  Investments = 'INVESTMENTS',
  Savings = 'SAVINGS'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Declined = 'DECLINED',
  Frozen = 'FROZEN',
  New = 'NEW',
  Pending = 'PENDING',
  PendingClosure = 'PENDING_CLOSURE',
  VerificationFailed = 'VERIFICATION_FAILED',
  VerificationInProgress = 'VERIFICATION_IN_PROGRESS'
}

export type UserSubscriptionInput = {
  statuses: Array<InputMaybe<SubscriptionStatus>>;
};

export enum UserTaxIdType {
  AustraliaAbn = 'AUSTRALIA_ABN',
  AustraliaTfn = 'AUSTRALIA_TFN',
  FranceSpi = 'FRANCE_SPI',
  GermanyTaxId = 'GERMANY_TAX_ID',
  Other = 'OTHER',
  UkUtr = 'UK_UTR',
  UsaSsn = 'USA_SSN'
}

export type UserTaxProfile = {
  countryOfTaxResidence: Scalars['String']['output'];
  /** @deprecated No use for the field */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  stateOfTaxResidence: Scalars['String']['output'];
  taxId: Scalars['String']['output'];
  taxIdType: UserTaxIdType;
  /** @deprecated No use for the field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum UserVisaStatus {
  A = 'A',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  Bcc = 'BCC',
  C = 'C',
  C5 = 'C5',
  Cr1 = 'CR1',
  Cr2 = 'CR2',
  Cw1 = 'CW1',
  D = 'D',
  Dv = 'DV',
  E = 'E',
  E1 = 'E1',
  E2 = 'E2',
  E3 = 'E3',
  Ew3 = 'EW3',
  F = 'F',
  F1 = 'F1',
  F2A = 'F2A',
  F2B = 'F2B',
  F3 = 'F3',
  F4 = 'F4',
  G1 = 'G1',
  G2 = 'G2',
  G3 = 'G3',
  G4 = 'G4',
  G5 = 'G5',
  GreenCard = 'GREEN_CARD',
  H1B = 'H1B',
  H1B1 = 'H1B1',
  H2A = 'H2A',
  H2B = 'H2B',
  H3 = 'H3',
  I = 'I',
  I5 = 'I5',
  Ih3 = 'IH3',
  Ih4 = 'IH4',
  Ir1 = 'IR1',
  Ir2 = 'IR2',
  Ir3 = 'IR3',
  Ir4 = 'IR4',
  Ir5 = 'IR5',
  J = 'J',
  K1 = 'K1',
  K3 = 'K3',
  L = 'L',
  M = 'M',
  Nato = 'NATO',
  Nato1 = 'NATO1',
  Nato2 = 'NATO2',
  Nato3 = 'NATO3',
  Nato4 = 'NATO4',
  Nato5 = 'NATO5',
  Nato6 = 'NATO6',
  O = 'O',
  P = 'P',
  Q = 'Q',
  R = 'R',
  R5 = 'R5',
  Sb = 'SB',
  Sd = 'SD',
  Si = 'SI',
  Sq = 'SQ',
  Sr = 'SR',
  T = 'T',
  T5 = 'T5',
  Td = 'TD',
  Tn = 'TN',
  U = 'U',
  V = 'V'
}

export type ValidateUserPrefill = {
  address: UserAddressInput;
  dateOfBirth?: InputMaybe<Scalars['DateOfBirth']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  ssn: Scalars['String']['input'];
};

export type VerifyEmailInput = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type VerifyPhoneNumber = {
  code: Scalars['String']['input'];
};

export type Waitlist = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type WeekEntries = {
  investmentEntries?: Maybe<Scalars['Int']['output']>;
  shakeEntries?: Maybe<Scalars['Int']['output']>;
  shakeSquadEntries?: Maybe<Scalars['Int']['output']>;
  totalEntries?: Maybe<Scalars['Int']['output']>;
};

export enum WithdrawalType {
  Withdrawal = 'WITHDRAWAL',
  WithdrawalAll = 'WITHDRAWAL_ALL'
}

export type BankLinkFragmentFragment = { id?: string | null, status?: BankLinkStatus | null, providerInstitutionId?: string | null, assets?: { name?: string | null, logo?: string | null } | null };

export type BankAccountFragmentFragment = { id?: string | null, bankAccountId?: string | null, accountNumber?: string | null, routingNumber?: string | null, name?: string | null, useForBilling?: boolean | null, assetLogo?: string | null, assetColor?: string | null };

export type SubscriptionFragmentFragment = { id: string, plan: SubscriptionPlan, billingInterval: BillingInterval, status: SubscriptionStatus, hasReachedAssetThreshold: boolean, assetThresholdPercent: number, nextBillingDate: any };

export type DocumentTypeInfoFragmentFragment = { type: DocumentType, title: string, description: string, count: number, unreadCount: number };

export type DocumentListFragmentFragment = { id?: string | null, title?: string | null, type?: DocumentType | null, documentDate?: string | null, isRead?: boolean | null };

export type DocumentFragmentFragment = { id?: string | null, title?: string | null, type?: DocumentType | null, documentDate?: string | null, url?: string | null, isRead?: boolean | null };

export type GoalFragmentFragment = { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, status?: GoalStatus | null, shared?: boolean | null, estimatedIrsBillInCents?: number | null, trumpAccountBalanceInCents?: number | null, trumpContributionAmountInCents?: number | null, trumpContributionFrequency?: TrumpContributionFrequency | null, partners?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, contributionsInCents?: number | null, accountType?: AccountType | null, currentAmountInCents?: number | null } | null> | null, sips?: Array<{ id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null } | null> | null, accounts?: Array<{ id?: string | null, type?: AccountType | null, balanceInCents?: number | null, title?: string | null, accountNumber?: string | null, contributionsManagedExternally: boolean, inAppContributionsAllowed: boolean, isHalfmoreSetupPending: boolean, needsPayrollSetup: boolean, harvestStandardDeduction?: boolean | null, harvestLongTermCapitalGains?: boolean | null, harvestRecommendedFloorUsd: number, subaccounts?: Array<{ id?: string | null } | null> | null } | null> | null };

export type InviteFragmentFragment = { id?: string | null, goalId?: string | null, phoneNumber?: string | null, status?: ShareGoalInviteStatus | null, expiry?: any | null };

export type PerformanceGraphFragmentFragment = { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null };

export type SipFragmentFragment = { id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null };

export type PromoCodeFragmentFragment = { name?: string | null, code?: string | null, active?: boolean | null, amountOff?: number | null, percentOff?: number | null, redemptionText?: string | null };

export type TransactionFragmentFragment = { id?: string | null, type?: TransactionType | null, status?: TransactionStatus | null, beneficiaryId?: string | null, beneficiaryName?: string | null, goalId?: string | null, goalName?: string | null, goalType?: GoalType | null, description?: string | null, amountInCents?: number | null, reason?: string | null, date?: string | null, scheduledDate?: string | null, processingDate?: string | null, completedDate?: string | null, estimatedCompletionDateRange?: string | null, subscriptionPeriod?: string | null };

export type UserFragmentFragment = { id?: string | null, partner?: string | null, partnerId?: string | null, partnerType?: PartnerType | null, provider?: AccountProvider | null, email?: string | null, firstName?: string | null, preferredName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, dateOfBirth?: any | null, language?: UserLanguage | null, residenceStatus?: UserResidenceStatus | null, countryOfCitizenship?: string | null, status?: UserStatus | null, termsAccepted?: boolean | null, maritalStatus?: UserMaritalStatus | null, userAddress?: { id?: string | null, unitNo?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, userFinancialProfile?: { id?: string | null, investmentPriority?: UserInvestmentPriority | null, investmentHorizon?: UserInvestmentHorizon | null, downturnReaction?: UserDownturnReaction | null, employmentStatus?: UserEmploymentStatus | null, employerName?: string | null, employerAddressUnitNo?: string | null, employerAddressStreet?: string | null, employerAddressCity?: string | null, employerAddressState?: string | null, employerAddressCountry?: string | null, employerAddressPostalCode?: string | null, occupationTitle?: OccupationTitle | null, occupationIndustry?: OccupationIndustry | null, isFinraAffiliated?: boolean | null, isPoliticallyExposed?: boolean | null, isFamilyPoliticallyExposed?: boolean | null, sourceOfFunds?: UserSourceOfFunds | null, liquidNetWorth?: UserLiquidNetWorth | null, annualIncome?: UserAnnualIncome | null, trustedContactFirstName?: string | null, trustedContactLastName?: string | null, trustedContactEmail?: string | null, trustedContactPhoneNumber?: string | null } | null, userTaxProfiles?: Array<{ id?: string | null, taxId: string, taxIdType: UserTaxIdType, countryOfTaxResidence: string, stateOfTaxResidence: string } | null> | null, settings?: { referralsEnabled: boolean, capitalGroupMigrationEnabled: boolean, capitalGroupMigrationInProgress: boolean, capitalGroupMigrationOverride: boolean, plaidRelinkBannerEnabled: boolean, achContributionFailedBankReLinkPopUp: boolean, achContributionNotProcessedBankReLinkPopUp: boolean, achConnectYourBankReLinkPopUp: boolean, achUnauthorizedPopUp: boolean } | null };

export type BeneficiariesFragmentFragment = { id?: string | null, type?: BeneficiaryType | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, taxIdProvided?: boolean | null, goals?: Array<{ id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, status?: GoalStatus | null, shared?: boolean | null, estimatedIrsBillInCents?: number | null, trumpAccountBalanceInCents?: number | null, trumpContributionAmountInCents?: number | null, trumpContributionFrequency?: TrumpContributionFrequency | null, partners?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, contributionsInCents?: number | null, accountType?: AccountType | null, currentAmountInCents?: number | null } | null> | null, sips?: Array<{ id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null } | null> | null, accounts?: Array<{ id?: string | null, type?: AccountType | null, balanceInCents?: number | null, title?: string | null, accountNumber?: string | null, contributionsManagedExternally: boolean, inAppContributionsAllowed: boolean, isHalfmoreSetupPending: boolean, needsPayrollSetup: boolean, harvestStandardDeduction?: boolean | null, harvestLongTermCapitalGains?: boolean | null, harvestRecommendedFloorUsd: number, subaccounts?: Array<{ id?: string | null } | null> | null } | null> | null } | null> | null };

export type CreateConsentMutationVariables = Exact<{
  agreementId: Scalars['String']['input'];
  viewedTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreateConsentMutation = { createConsent: { id: string, agreementId: string, agreementType: AgreementType, agreementVersion: string, signedTimestamp: any } };

export type AcknowledgeCapitalGroupMigrationOverrideMutationVariables = Exact<{ [key: string]: never; }>;


export type AcknowledgeCapitalGroupMigrationOverrideMutation = { acknowledgeCapitalGroupMigrationOverride: boolean };

export type ProcessPublicTokenMutationVariables = Exact<{
  institutionId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
}>;


export type ProcessPublicTokenMutation = { processPublicToken?: boolean | null };

export type LoginUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginUserMutation = { loginUser: { sessionJwt: string, sessionToken?: string | null } };

export type RegisterUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  promotionCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterUserMutation = { registerUser: { sessionJwt: string, sessionToken?: string | null } };

export type InitiateLoginWithPhoneMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type InitiateLoginWithPhoneMutation = { initiateLoginWithPhone: boolean };

export type RegisterWithPhoneMutationVariables = Exact<{
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  promotionCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterWithPhoneMutation = { registerWithPhone: boolean };

export type LoginWithPhoneMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  code: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoginWithPhoneMutation = { loginWithPhone: { sessionJwt: string, sessionToken?: string | null } };

export type LoginWithOAuthMutationVariables = Exact<{
  jwt: Scalars['String']['input'];
  channel?: InputMaybe<OAuthChannel>;
}>;


export type LoginWithOAuthMutation = { loginWithOAuth: { sessionJwt: string, sessionToken?: string | null } };

export type RefreshTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RefreshTokenMutation = { refreshToken: { sessionJwt: string, sessionToken?: string | null } };

export type InitiateResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type InitiateResetPasswordMutation = { initiateResetPassword: boolean };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { resetPassword: boolean };

export type CreateWithdrawalMutationVariables = Exact<{
  goalId: Scalars['String']['input'];
  amountInCents: Scalars['Int']['input'];
  subaccountId?: InputMaybe<Scalars['String']['input']>;
  cancelExistingWithdrawal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateWithdrawalMutation = { createWithdrawal: { id?: string | null, label?: TransactionLabel | null, type?: TransactionType | null, status?: TransactionStatus | null, description?: string | null, amountInCents?: number | null, date?: string | null, reason?: string | null } };

export type UpdateSubscriptionMutationVariables = Exact<{
  planOption: PlanOption;
}>;


export type UpdateSubscriptionMutation = { updateSubscription?: { id: string, plan: SubscriptionPlan, billingInterval: BillingInterval, status: SubscriptionStatus, hasReachedAssetThreshold: boolean, assetThresholdPercent: number, nextBillingDate: any } | null };

export type CreateOneTimeDepositMutationVariables = Exact<{
  goalId: Scalars['String']['input'];
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  amountInCents: Scalars['Int']['input'];
}>;


export type CreateOneTimeDepositMutation = { createOneTimeDeposit: { id?: string | null, type?: TransactionType | null, status?: TransactionStatus | null, beneficiaryId?: string | null, beneficiaryName?: string | null, goalId?: string | null, goalName?: string | null, goalType?: GoalType | null, description?: string | null, amountInCents?: number | null, reason?: string | null, date?: string | null, scheduledDate?: string | null, processingDate?: string | null, completedDate?: string | null, estimatedCompletionDateRange?: string | null, subscriptionPeriod?: string | null } };

export type ConfirmBeneficiaryGiftingCodeMutationVariables = Exact<{
  beneficiaryId: Scalars['String']['input'];
}>;


export type ConfirmBeneficiaryGiftingCodeMutation = { confirmBeneficiaryGiftingCode?: { giftingUrl: string, giftingCode: string, isGiftingCodeConfirmed: boolean } | null };

export type UpdateBeneficiaryGiftingCodeMutationVariables = Exact<{
  beneficiaryId: Scalars['String']['input'];
  newGiftingCode: Scalars['String']['input'];
}>;


export type UpdateBeneficiaryGiftingCodeMutation = { updateBeneficiaryGiftingCode?: { giftingUrl: string, giftingCode: string, isGiftingCodeConfirmed: boolean } | null };

export type AddGoalMutationVariables = Exact<{
  beneficiaryId: Scalars['String']['input'];
  goalType?: InputMaybe<GoalType>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  accountType: AccountType;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
  targetAmountInCents?: InputMaybe<Scalars['Float']['input']>;
  recurringDepositInCents?: InputMaybe<Scalars['Int']['input']>;
  recurringDepositSchedule?: InputMaybe<SipFrequency>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  harvestStandardDeduction?: InputMaybe<Scalars['Boolean']['input']>;
  harvestLongTermCapitalGains?: InputMaybe<Scalars['Boolean']['input']>;
  harvestRecommendedFloorUsd?: InputMaybe<Scalars['Int']['input']>;
  trumpAccountBalanceInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionFrequency?: InputMaybe<TrumpContributionFrequency>;
  expectedTaxBillWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  expectedTaxBillWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  spendableWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  spendableWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  incomeAt18?: InputMaybe<IncomeAt18>;
}>;


export type AddGoalMutation = { addGoal?: { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, status?: GoalStatus | null, contributionsAfter18?: boolean | null, projectedRateOfReturn?: number | null } | null };

export type AddGoalWithBeneficiaryMutationVariables = Exact<{
  beneficiary: AddBeneficiaryInput;
  accountType: AccountType;
  goalType?: InputMaybe<GoalType>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
  targetAmountInCents: Scalars['Float']['input'];
  recurringDepositInCents?: InputMaybe<Scalars['Int']['input']>;
  recurringDepositSchedule?: InputMaybe<SipFrequency>;
  projectedRateOfReturn: Scalars['Float']['input'];
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  harvestStandardDeduction?: InputMaybe<Scalars['Boolean']['input']>;
  harvestLongTermCapitalGains?: InputMaybe<Scalars['Boolean']['input']>;
  harvestRecommendedFloorUsd?: InputMaybe<Scalars['Int']['input']>;
  trumpAccountBalanceInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionFrequency?: InputMaybe<TrumpContributionFrequency>;
  expectedTaxBillWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  expectedTaxBillWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  spendableWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  spendableWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  incomeAt18?: InputMaybe<IncomeAt18>;
}>;


export type AddGoalWithBeneficiaryMutation = { addGoalWithBeneficiary?: { beneficiary: { id?: string | null }, goal: { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, status?: GoalStatus | null, contributionsAfter18?: boolean | null, projectedRateOfReturn?: number | null } } | null };

export type EditGoalMutationVariables = Exact<{
  goalId: Scalars['String']['input'];
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<GoalType>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
  targetAmountInCents?: InputMaybe<Scalars['Float']['input']>;
  trumpAccountBalanceInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  trumpContributionFrequency?: InputMaybe<TrumpContributionFrequency>;
  expectedTaxBillWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  expectedTaxBillWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  spendableWithoutSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  spendableWithSidecarInCents?: InputMaybe<Scalars['Float']['input']>;
  incomeAt18?: InputMaybe<IncomeAt18>;
}>;


export type EditGoalMutation = { editGoal?: { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, status?: GoalStatus | null, contributionsAfter18?: boolean | null, projectedRateOfReturn?: number | null, trumpAccountBalanceInCents?: number | null, trumpContributionAmountInCents?: number | null, trumpContributionFrequency?: TrumpContributionFrequency | null } | null };

export type UpdateHarvestAccountConfigsMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  harvestStandardDeduction?: InputMaybe<Scalars['Boolean']['input']>;
  harvestLongTermCapitalGains?: InputMaybe<Scalars['Boolean']['input']>;
  harvestRecommendedFloorUsd?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateHarvestAccountConfigsMutation = { updateHarvestAccountConfigs?: { id?: string | null, harvestStandardDeduction?: boolean | null, harvestLongTermCapitalGains?: boolean | null, harvestRecommendedFloorUsd: number } | null };

export type InviteToShareGoalMutationVariables = Exact<{
  goalId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type InviteToShareGoalMutation = { inviteToShareGoal?: { id?: string | null, goalId?: string | null, phoneNumber?: string | null, status?: ShareGoalInviteStatus | null, expiry?: any | null } | null };

export type DeleteInviteToShareGoalMutationVariables = Exact<{
  shareGoalInviteId: Scalars['String']['input'];
}>;


export type DeleteInviteToShareGoalMutation = { deleteInviteToShareGoal?: boolean | null };

export type ResendInviteToShareGoalMutationVariables = Exact<{
  shareGoalInviteId: Scalars['String']['input'];
}>;


export type ResendInviteToShareGoalMutation = { resendInviteToShareGoal?: { id?: string | null, goalId?: string | null, phoneNumber?: string | null, status?: ShareGoalInviteStatus | null, expiry?: any | null } | null };

export type ActionShareGoalInviteMutationVariables = Exact<{
  shareGoalInviteId: Scalars['String']['input'];
  action: ShareGoalInviteAction;
  accountType?: InputMaybe<AccountType>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  recurringDepositInCents?: InputMaybe<Scalars['Int']['input']>;
  recurringDepositSchedule?: InputMaybe<SipFrequency>;
  targetAmountInCents?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ActionShareGoalInviteMutation = { actionShareGoalInvite?: { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, status?: GoalStatus | null, shared?: boolean | null, estimatedIrsBillInCents?: number | null, trumpAccountBalanceInCents?: number | null, trumpContributionAmountInCents?: number | null, trumpContributionFrequency?: TrumpContributionFrequency | null, partners?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, contributionsInCents?: number | null, accountType?: AccountType | null, currentAmountInCents?: number | null } | null> | null, sips?: Array<{ id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null } | null> | null, accounts?: Array<{ id?: string | null, type?: AccountType | null, balanceInCents?: number | null, title?: string | null, accountNumber?: string | null, contributionsManagedExternally: boolean, inAppContributionsAllowed: boolean, isHalfmoreSetupPending: boolean, needsPayrollSetup: boolean, harvestStandardDeduction?: boolean | null, harvestLongTermCapitalGains?: boolean | null, harvestRecommendedFloorUsd: number, subaccounts?: Array<{ id?: string | null } | null> | null } | null> | null } | null };

export type RemovePartnerFromGoalMutationVariables = Exact<{
  goalId: Scalars['String']['input'];
  partnerId: Scalars['String']['input'];
}>;


export type RemovePartnerFromGoalMutation = { removePartnerFromGoal?: { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, status?: GoalStatus | null, shared?: boolean | null, estimatedIrsBillInCents?: number | null, trumpAccountBalanceInCents?: number | null, trumpContributionAmountInCents?: number | null, trumpContributionFrequency?: TrumpContributionFrequency | null, partners?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, contributionsInCents?: number | null, accountType?: AccountType | null, currentAmountInCents?: number | null } | null> | null, sips?: Array<{ id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null } | null> | null, accounts?: Array<{ id?: string | null, type?: AccountType | null, balanceInCents?: number | null, title?: string | null, accountNumber?: string | null, contributionsManagedExternally: boolean, inAppContributionsAllowed: boolean, isHalfmoreSetupPending: boolean, needsPayrollSetup: boolean, harvestStandardDeduction?: boolean | null, harvestLongTermCapitalGains?: boolean | null, harvestRecommendedFloorUsd: number, subaccounts?: Array<{ id?: string | null } | null> | null } | null> | null } | null };

export type SetUserFinancialProfileMutationVariables = Exact<{
  investmentPriority?: InputMaybe<UserInvestmentPriority>;
  investmentHorizon?: InputMaybe<UserInvestmentHorizon>;
  downturnReaction?: InputMaybe<UserDownturnReaction>;
  employmentStatus?: InputMaybe<UserEmploymentStatus>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  employerAddressUnitNo?: InputMaybe<Scalars['String']['input']>;
  employerAddressStreet?: InputMaybe<Scalars['String']['input']>;
  employerAddressCity?: InputMaybe<Scalars['String']['input']>;
  employerAddressState?: InputMaybe<Scalars['String']['input']>;
  employerAddressCountry?: InputMaybe<Scalars['String']['input']>;
  employerAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<OccupationTitle>;
  industry?: InputMaybe<OccupationIndustry>;
  sourceOfFunds?: InputMaybe<UserSourceOfFunds>;
  liquidNetWorth?: InputMaybe<UserLiquidNetWorth>;
  annualIncome?: InputMaybe<UserAnnualIncome>;
}>;


export type SetUserFinancialProfileMutation = { setUserFinancialProfile?: { id?: string | null } | null };

export type ChangeRecurringDepositMutationVariables = Exact<{
  sipId: Scalars['String']['input'];
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<SipFrequency>;
}>;


export type ChangeRecurringDepositMutation = { changeRecurringDeposit: { id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, status?: SipStatus | null } };

export type PauseRecurringDepositMutationVariables = Exact<{
  sipId: Scalars['String']['input'];
}>;


export type PauseRecurringDepositMutation = { pauseRecurringDeposit: { id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, status?: SipStatus | null } };

export type ResumeRecurringDepositMutationVariables = Exact<{
  sipId: Scalars['String']['input'];
}>;


export type ResumeRecurringDepositMutation = { resumeRecurringDeposit: { id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, status?: SipStatus | null } };

export type CancelContributionMutationVariables = Exact<{
  transactionId: Scalars['String']['input'];
}>;


export type CancelContributionMutation = { cancelContribution: { id?: string | null, type?: TransactionType | null, status?: TransactionStatus | null, beneficiaryId?: string | null, beneficiaryName?: string | null, goalId?: string | null, goalName?: string | null, goalType?: GoalType | null, description?: string | null, amountInCents?: number | null, reason?: string | null, date?: string | null, scheduledDate?: string | null, processingDate?: string | null, completedDate?: string | null, estimatedCompletionDateRange?: string | null, subscriptionPeriod?: string | null } };

export type CreateRecurringDepositMutationVariables = Exact<{
  goalId: Scalars['String']['input'];
  amountInCents: Scalars['Int']['input'];
  frequency: SipFrequency;
}>;


export type CreateRecurringDepositMutation = { createRecurringDeposit: { id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, status?: SipStatus | null } };

export type VerifyPhoneNumberMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type VerifyPhoneNumberMutation = { verifyPhoneNumber?: boolean | null };

export type VerifyEmailMutationVariables = Exact<{
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type VerifyEmailMutation = { verifyEmail: { token: string } };

export type CreateTermsConsentMutationVariables = Exact<{
  viewedTimestamp: Scalars['DateTime']['input'];
}>;


export type CreateTermsConsentMutation = { createTermsConsent?: boolean | null };

export type ValidateUserPrefillMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  dateOfBirth: Scalars['DateOfBirth']['input'];
  address: UserAddressInput;
  ssn: Scalars['String']['input'];
}>;


export type ValidateUserPrefillMutation = { validateUserPrefill?: boolean | null };

export type AllocatePromotionalDollarsMutationVariables = Exact<{
  amountInCents: Scalars['Int']['input'];
  destinationGoalId: Scalars['String']['input'];
}>;


export type AllocatePromotionalDollarsMutation = { allocatePromotionalDollars: { id?: string | null, type?: TransactionType | null, status?: TransactionStatus | null, beneficiaryId?: string | null, beneficiaryName?: string | null, goalId?: string | null, goalName?: string | null, goalType?: GoalType | null, description?: string | null, amountInCents?: number | null, reason?: string | null, date?: string | null, scheduledDate?: string | null, processingDate?: string | null, completedDate?: string | null, estimatedCompletionDateRange?: string | null, subscriptionPeriod?: string | null } };

export type VerifyPromotionCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type VerifyPromotionCodeMutation = { verifyPromotionCode?: { name?: string | null, code?: string | null, active?: boolean | null, amountOff?: number | null, percentOff?: number | null, redemptionText?: string | null } | null };

export type RedeemPromotionCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type RedeemPromotionCodeMutation = { redeemPromotionCode?: { name?: string | null, code?: string | null, active?: boolean | null, amountOff?: number | null, percentOff?: number | null, redemptionText?: string | null } | null };

export type SetUserIdentityMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<UserAddressInput>;
  countryOfCitizenship?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  residenceStatus?: InputMaybe<UserResidenceStatus>;
  maritalStatus?: InputMaybe<UserMaritalStatus>;
  spouseFirstName?: InputMaybe<Scalars['String']['input']>;
  spouseLastName?: InputMaybe<Scalars['String']['input']>;
  spouseDateOfBirth?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetUserIdentityMutation = { setUserIdentity?: { id?: string | null, partner?: string | null, partnerId?: string | null, partnerType?: PartnerType | null, provider?: AccountProvider | null, email?: string | null, firstName?: string | null, preferredName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, dateOfBirth?: any | null, language?: UserLanguage | null, residenceStatus?: UserResidenceStatus | null, countryOfCitizenship?: string | null, status?: UserStatus | null, termsAccepted?: boolean | null, maritalStatus?: UserMaritalStatus | null, userAddress?: { id?: string | null, unitNo?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, userFinancialProfile?: { id?: string | null, investmentPriority?: UserInvestmentPriority | null, investmentHorizon?: UserInvestmentHorizon | null, downturnReaction?: UserDownturnReaction | null, employmentStatus?: UserEmploymentStatus | null, employerName?: string | null, employerAddressUnitNo?: string | null, employerAddressStreet?: string | null, employerAddressCity?: string | null, employerAddressState?: string | null, employerAddressCountry?: string | null, employerAddressPostalCode?: string | null, occupationTitle?: OccupationTitle | null, occupationIndustry?: OccupationIndustry | null, isFinraAffiliated?: boolean | null, isPoliticallyExposed?: boolean | null, isFamilyPoliticallyExposed?: boolean | null, sourceOfFunds?: UserSourceOfFunds | null, liquidNetWorth?: UserLiquidNetWorth | null, annualIncome?: UserAnnualIncome | null, trustedContactFirstName?: string | null, trustedContactLastName?: string | null, trustedContactEmail?: string | null, trustedContactPhoneNumber?: string | null } | null, userTaxProfiles?: Array<{ id?: string | null, taxId: string, taxIdType: UserTaxIdType, countryOfTaxResidence: string, stateOfTaxResidence: string } | null> | null, settings?: { referralsEnabled: boolean, capitalGroupMigrationEnabled: boolean, capitalGroupMigrationInProgress: boolean, capitalGroupMigrationOverride: boolean, plaidRelinkBannerEnabled: boolean, achContributionFailedBankReLinkPopUp: boolean, achContributionNotProcessedBankReLinkPopUp: boolean, achConnectYourBankReLinkPopUp: boolean, achUnauthorizedPopUp: boolean } | null } | null };

export type SetUserTaxProfileMutationVariables = Exact<{
  taxId: Scalars['String']['input'];
  taxIdType: UserTaxIdType;
  countryOfTaxResidence: Scalars['String']['input'];
  stateOfTaxResidence: Scalars['String']['input'];
}>;


export type SetUserTaxProfileMutation = { setUserTaxProfile?: { id?: string | null, partner?: string | null, partnerId?: string | null, partnerType?: PartnerType | null, provider?: AccountProvider | null, email?: string | null, firstName?: string | null, preferredName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, dateOfBirth?: any | null, language?: UserLanguage | null, residenceStatus?: UserResidenceStatus | null, countryOfCitizenship?: string | null, status?: UserStatus | null, termsAccepted?: boolean | null, maritalStatus?: UserMaritalStatus | null, userAddress?: { id?: string | null, unitNo?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, userFinancialProfile?: { id?: string | null, investmentPriority?: UserInvestmentPriority | null, investmentHorizon?: UserInvestmentHorizon | null, downturnReaction?: UserDownturnReaction | null, employmentStatus?: UserEmploymentStatus | null, employerName?: string | null, employerAddressUnitNo?: string | null, employerAddressStreet?: string | null, employerAddressCity?: string | null, employerAddressState?: string | null, employerAddressCountry?: string | null, employerAddressPostalCode?: string | null, occupationTitle?: OccupationTitle | null, occupationIndustry?: OccupationIndustry | null, isFinraAffiliated?: boolean | null, isPoliticallyExposed?: boolean | null, isFamilyPoliticallyExposed?: boolean | null, sourceOfFunds?: UserSourceOfFunds | null, liquidNetWorth?: UserLiquidNetWorth | null, annualIncome?: UserAnnualIncome | null, trustedContactFirstName?: string | null, trustedContactLastName?: string | null, trustedContactEmail?: string | null, trustedContactPhoneNumber?: string | null } | null, userTaxProfiles?: Array<{ id?: string | null, taxId: string, taxIdType: UserTaxIdType, countryOfTaxResidence: string, stateOfTaxResidence: string } | null> | null, settings?: { referralsEnabled: boolean, capitalGroupMigrationEnabled: boolean, capitalGroupMigrationInProgress: boolean, capitalGroupMigrationOverride: boolean, plaidRelinkBannerEnabled: boolean, achContributionFailedBankReLinkPopUp: boolean, achContributionNotProcessedBankReLinkPopUp: boolean, achConnectYourBankReLinkPopUp: boolean, achUnauthorizedPopUp: boolean } | null } | null };

export type AddBeneficiaryMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateOfBirth']['input']>;
  type: BeneficiaryType;
  taxId?: InputMaybe<Scalars['String']['input']>;
  incomeAt18?: InputMaybe<IncomeAt18>;
}>;


export type AddBeneficiaryMutation = { addBeneficiary?: { id?: string | null, type?: BeneficiaryType | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, goals?: Array<{ id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, status?: GoalStatus | null } | null> | null } | null };

export type UpdateBeneficiaryMutationVariables = Exact<{
  beneficiaryId: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateOfBirth']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateBeneficiaryMutation = { updateBeneficiary?: { id?: string | null, type?: BeneficiaryType | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, goals?: Array<{ id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, status?: GoalStatus | null } | null> | null } | null };

export type SetUserTrustedContactMutationVariables = Exact<{
  trustedContactFirstName?: InputMaybe<Scalars['String']['input']>;
  trustedContactLastName?: InputMaybe<Scalars['String']['input']>;
  trustedContactEmail?: InputMaybe<Scalars['String']['input']>;
  trustedContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetUserTrustedContactMutation = { setUserTrustedContact?: { id?: string | null, trustedContactFirstName?: string | null, trustedContactLastName?: string | null, trustedContactEmail?: string | null, trustedContactPhoneNumber?: string | null } | null };

export type AddressPredictionsQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type AddressPredictionsQuery = { addressPredictions?: { predictions?: Array<{ placeId: string, description: string } | null> | null } | null };

export type AddressDetailsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;


export type AddressDetailsQuery = { addressDetails?: { streetName?: string | null, streetNumber?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null };

export type BusinessAddressQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type BusinessAddressQuery = { businessAddress?: { address?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { countries?: any | null };

export type CurrentAgreementQueryVariables = Exact<{
  type: AgreementType;
}>;


export type CurrentAgreementQuery = { currentAgreement?: { id: string, type: AgreementType, version: string, title: string, url?: string | null } | null };

export type IsSupportedVersionQueryVariables = Exact<{
  version: Scalars['String']['input'];
}>;


export type IsSupportedVersionQuery = { isSupportedVersion?: boolean | null };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = { featureFlags: Array<{ name: string, value: any }> };

export type GetBankLinkTokenQueryVariables = Exact<{
  input?: InputMaybe<GetBankLinkTokenInput>;
}>;


export type GetBankLinkTokenQuery = { getBankLinkToken?: { provider: string, token: string } | null };

export type GetSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionQuery = { getSubscription?: { id: string, plan: SubscriptionPlan, billingInterval: BillingInterval, status: SubscriptionStatus, hasReachedAssetThreshold: boolean, assetThresholdPercent: number, nextBillingDate: any } | null };

export type DocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentTypesQuery = { documentTypes: Array<{ type: DocumentType, title: string, description: string, count: number, unreadCount: number }> };

export type DocumentsQueryVariables = Exact<{
  input: DocumentsInput;
}>;


export type DocumentsQuery = { documents: Array<{ id?: string | null, title?: string | null, type?: DocumentType | null, documentDate?: string | null, isRead?: boolean | null }> };

export type DocumentQueryVariables = Exact<{
  input: DocumentInput;
}>;


export type DocumentQuery = { document: { id?: string | null, title?: string | null, type?: DocumentType | null, documentDate?: string | null, url?: string | null, isRead?: boolean | null } };

export type BeneficiaryGiftingLinkQueryVariables = Exact<{
  beneficiaryId: Scalars['String']['input'];
}>;


export type BeneficiaryGiftingLinkQuery = { beneficiaryGiftingLink?: { giftingUrl: string, giftingCode: string, isGiftingCodeConfirmed: boolean } | null };

export type CheckGiftingCodeAvailabilityQueryVariables = Exact<{
  giftingCode: Scalars['String']['input'];
  beneficiaryId: Scalars['String']['input'];
}>;


export type CheckGiftingCodeAvailabilityQuery = { checkGiftingCodeAvailability?: { isAvailable: boolean } | null };

export type GoalDetailsBreakdownQueryVariables = Exact<{
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  goalId: Scalars['String']['input'];
  nodeCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GoalDetailsBreakdownQuery = { oneDay: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneWeek: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneMonth: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, sixMonth: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneYear: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, fiveYear: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, portfolioBreakdown: { totalValueInCents?: number | null, contributionsInCents?: number | null, returnsInCents?: number | null, sectorExposures?: Array<{ name: PortfolioSectorExposureNames, factorPercentage: number } | null> | null, assetClassExposures?: Array<{ name: PortfolioAssetExposureNames, factorPercentage: number } | null> | null }, portfolioPositions: Array<{ symbol: string, name: string, shares: number, sharePriceInCents: number, totalValueInCents: number, changeTodayAmountInCents?: number | null, changeTodayPercentage?: number | null } | null> };

export type HarvestAccountDefaultConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type HarvestAccountDefaultConfigsQuery = { harvestAccountDefaultConfigs?: { harvestStandardDeduction: boolean, harvestLongTermCapitalGains: boolean, harvestRecommendedFloorUsd: number, reason: string } | null };

export type SentShareGoalInvitesQueryVariables = Exact<{
  goalId: Scalars['String']['input'];
}>;


export type SentShareGoalInvitesQuery = { sentShareGoalInvites?: Array<{ id?: string | null, goalId?: string | null, phoneNumber?: string | null, status?: ShareGoalInviteStatus | null, expiry?: any | null } | null> | null };

export type ReceivedShareGoalInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type ReceivedShareGoalInvitesQuery = { receivedShareGoalInvites?: Array<{ id?: string | null, goalName?: string | null, goalType?: GoalType | null, beneficiaryType?: BeneficiaryType | null, inviterFirstName?: string | null, inviterLastName?: string | null, currentAmountInCents?: number | null, targetAmountInCents?: number | null, targetYear?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, status?: ShareGoalInviteStatus | null, expiry?: any | null, partnerGoalContributions?: Array<{ partnerId?: string | null, partnerFirstName?: string | null, partnerLastName?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null } | null> | null } | null> | null };

export type SuggestedAccountTypeQueryVariables = Exact<{
  input: SuggestedAccountTypeInput;
}>;


export type SuggestedAccountTypeQuery = { suggestedAccountType: { recommended: AccountType, alternatives: Array<AccountType> } };

export type PortfolioPerformanceGraphQueryVariables = Exact<{
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['String']['input']>;
  nodeCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PortfolioPerformanceGraphQuery = { oneDay: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneWeek: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneMonth: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, sixMonth: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneYear: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, fiveYear: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null } };

export type UserPrefillDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPrefillDataQuery = { userPrefillData?: { firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, dateOfBirth?: string | null, ssn?: string | null, address?: { unitNo?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null } | null };

export type PromotionalDollarQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PromotionalDollarQueryQuery = { promotionalDollarBalanceInCents: number, userPromotionCodeRedemptions?: Array<{ id: string, status: UserPromotionCodeStatus, promotionCode: { name?: string | null, code?: string | null, active?: boolean | null, amountOff?: number | null, percentOff?: number | null, redemptionText?: string | null } } | null> | null };

export type UserReferralDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserReferralDataQuery = { userReferralData?: { referralUrl: string, referralAmountInCents?: number | null, inviteText: string, earnedBonusInCents: number, pendingBonusInCents: number, referrals: Array<{ firstName?: string | null, lastName?: string | null, signedUpAt?: any | null, activatedAt?: any | null, contributedAt?: any | null, status?: UserReferralStatus | null } | null> } | null };

export type TransactionsQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<TransactionTime>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type TransactionsQuery = { transactions?: { size?: number | null, nextCursor?: string | null, elements: Array<{ id?: string | null, type?: TransactionType | null, status?: TransactionStatus | null, beneficiaryId?: string | null, beneficiaryName?: string | null, goalId?: string | null, goalName?: string | null, goalType?: GoalType | null, description?: string | null, amountInCents?: number | null, reason?: string | null, date?: string | null, scheduledDate?: string | null, processingDate?: string | null, completedDate?: string | null, estimatedCompletionDateRange?: string | null, subscriptionPeriod?: string | null } | null> } | null };

export type AvailableToWithdrawInCentsQueryVariables = Exact<{
  goalId: Scalars['String']['input'];
  subaccountId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AvailableToWithdrawInCentsQuery = { availableToWithdrawInCents: { netAvailableToWithdrawInCents?: number | null, grossAvailableToWithdrawInCents?: number | null, pendingContributionsInCents?: number | null, pendingWithdrawalsInCents?: number | null, isWithdrawalAllInitiated?: boolean | null, lockedPromotionalDollarsInCents?: number | null } };

export type IsWithdrawalAllowedQueryVariables = Exact<{
  goalId: Scalars['String']['input'];
  subaccountId?: InputMaybe<Scalars['String']['input']>;
}>;


export type IsWithdrawalAllowedQuery = { isWithdrawalAllowed: { allowed: boolean, cancellationRequired: boolean, reason?: string | null } };

export type FailedAchContributionQueryVariables = Exact<{ [key: string]: never; }>;


export type FailedAchContributionQuery = { failedAchContribution?: { id: string, transactionId: string, returnCode?: string | null, returnReason?: string | null, occurrenceNumber: number, createdAt: string, failedTransaction?: { id?: string | null, type?: TransactionType | null, status?: TransactionStatus | null, beneficiaryId?: string | null, beneficiaryName?: string | null, goalId?: string | null, goalName?: string | null, goalType?: GoalType | null, description?: string | null, amountInCents?: number | null, reason?: string | null, date?: string | null, scheduledDate?: string | null, processingDate?: string | null, completedDate?: string | null, estimatedCompletionDateRange?: string | null, subscriptionPeriod?: string | null } | null } | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { user?: { id?: string | null, partner?: string | null, partnerId?: string | null, partnerType?: PartnerType | null, provider?: AccountProvider | null, email?: string | null, firstName?: string | null, preferredName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, dateOfBirth?: any | null, language?: UserLanguage | null, residenceStatus?: UserResidenceStatus | null, countryOfCitizenship?: string | null, status?: UserStatus | null, termsAccepted?: boolean | null, maritalStatus?: UserMaritalStatus | null, userAddress?: { id?: string | null, unitNo?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, userFinancialProfile?: { id?: string | null, investmentPriority?: UserInvestmentPriority | null, investmentHorizon?: UserInvestmentHorizon | null, downturnReaction?: UserDownturnReaction | null, employmentStatus?: UserEmploymentStatus | null, employerName?: string | null, employerAddressUnitNo?: string | null, employerAddressStreet?: string | null, employerAddressCity?: string | null, employerAddressState?: string | null, employerAddressCountry?: string | null, employerAddressPostalCode?: string | null, occupationTitle?: OccupationTitle | null, occupationIndustry?: OccupationIndustry | null, isFinraAffiliated?: boolean | null, isPoliticallyExposed?: boolean | null, isFamilyPoliticallyExposed?: boolean | null, sourceOfFunds?: UserSourceOfFunds | null, liquidNetWorth?: UserLiquidNetWorth | null, annualIncome?: UserAnnualIncome | null, trustedContactFirstName?: string | null, trustedContactLastName?: string | null, trustedContactEmail?: string | null, trustedContactPhoneNumber?: string | null } | null, userTaxProfiles?: Array<{ id?: string | null, taxId: string, taxIdType: UserTaxIdType, countryOfTaxResidence: string, stateOfTaxResidence: string } | null> | null, settings?: { referralsEnabled: boolean, capitalGroupMigrationEnabled: boolean, capitalGroupMigrationInProgress: boolean, capitalGroupMigrationOverride: boolean, plaidRelinkBannerEnabled: boolean, achContributionFailedBankReLinkPopUp: boolean, achContributionNotProcessedBankReLinkPopUp: boolean, achConnectYourBankReLinkPopUp: boolean, achUnauthorizedPopUp: boolean } | null } | null, beneficiaries?: Array<{ id?: string | null, type?: BeneficiaryType | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, taxIdProvided?: boolean | null, goals?: Array<{ id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, status?: GoalStatus | null, shared?: boolean | null, estimatedIrsBillInCents?: number | null, trumpAccountBalanceInCents?: number | null, trumpContributionAmountInCents?: number | null, trumpContributionFrequency?: TrumpContributionFrequency | null, partners?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, contributionsInCents?: number | null, accountType?: AccountType | null, currentAmountInCents?: number | null } | null> | null, sips?: Array<{ id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null } | null> | null, accounts?: Array<{ id?: string | null, type?: AccountType | null, balanceInCents?: number | null, title?: string | null, accountNumber?: string | null, contributionsManagedExternally: boolean, inAppContributionsAllowed: boolean, isHalfmoreSetupPending: boolean, needsPayrollSetup: boolean, harvestStandardDeduction?: boolean | null, harvestLongTermCapitalGains?: boolean | null, harvestRecommendedFloorUsd: number, subaccounts?: Array<{ id?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, getBankLinks?: Array<{ id?: string | null, status?: BankLinkStatus | null, providerInstitutionId?: string | null, assets?: { name?: string | null, logo?: string | null } | null } | null> | null, getBankAccounts?: Array<{ id?: string | null, bankAccountId?: string | null, accountNumber?: string | null, routingNumber?: string | null, name?: string | null, useForBilling?: boolean | null, assetLogo?: string | null, assetColor?: string | null }> | null };

export type IndustriesQueryVariables = Exact<{ [key: string]: never; }>;


export type IndustriesQuery = { industries?: any | null };

export type OccupationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OccupationsQuery = { occupations?: any | null };
